import { EnableDisableDirective } from './../../Directives/enable-disable.directive';
import { Modal } from 'bootstrap';
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/loader.service';
import { CommonPatternsService } from './../../common-patterns.service';

import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { PhoneFormatPipe } from '../../pipes/phone-format.pipe';
import { salesTrackingFormater } from 'src/app/pipes/SalesTrackingcode-formar';
import { SalestrackingcodePipe } from 'src/app/pipes/salestrackingcode.pipe';
// import{seles}
import * as moment from 'moment';
import { Title } from '@angular/platform-browser';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import Chart from 'chart.js/auto';
import { Store } from '@ngrx/store';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { selectAdvisorData, selectAdvisorError, selectAdvisorLoading } from 'src/app/state/selectors/advisors.selector';
import { loadAdvisorData, loadAdvisorDataSuccess } from 'src/app/state/actions/advisors.actions';
import { loadLanguageData } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadBrokerFormConfigData } from 'src/app/state/actions/brokerFormConfig.actions';
import { selectBrokerFormConfigData } from 'src/app/state/selectors/brokerFormConfig.selector';
import { loadBrokerConfigData } from 'src/app/state/actions/brokerConfig.actions';
import { selectBrokerConfigData } from 'src/app/state/selectors/brokerConfig.selector';

declare var $: any;
@Component({
  selector: 'app-addbrokerDetails',
  templateUrl: './addbrokerDetails.component.html',
  styleUrls: ['./addbrokerDetails.component.css'],
  providers: [
    DatePipe,
    PhoneFormatPipe,
    salesTrackingFormater,
    SalestrackingcodePipe,
  ],
})
export class AddbrokerDetailsComponent implements OnInit {
  adminName: any;
  todayDate: any;
  public id: string;
  showsharedExistingButton: boolean = false;
  showaddadmin = false;
  showformtype = false;
  showaddform = false;
  addlicenseform = true;
  showaddEOdetails = false;
  addEOform = true;
  isEditable = true;
  enableEditIndex = null;
  public pieChartLabels: string[] = ['Chrome', 'Safari', 'Firefox', 'Internet Explorer', 'Other'];
  public pieChartData: number[] = [40, 20, 20, 10, 10];
  public pieChartType: string = 'pie';
  isEditableForm = true;
  enableEditIndexForm = null;

  isChecked: boolean = true;
  formTitle: any;
  formDescription: any;
  showFormsDetails = false;
  editFormType: any;
  editFormName: any;
  editFormProfile: any;
  editFormDescription: any;
  editFormlink: any;
  editFormlogo: any;
  editFormdisplaylogo: any;
  editFormDisclousreAggrement: any;
  editFormPricingOptions: any;
  showsoleAdvisorData = false;
  showSharedNewData = false;
  addlicenseformtable = false;
  addlicenseformData: Array<any> = [];
  addeofromDetails: any;
  planLevels: any = [];
  addformDetails: Array<any> = [];
  fromplansarry: Array<any> = [];
  finalSummaryData: Array<any> = [];
  finalSummaryDataEOinsurance: Array<any> = [];
  finalSummaryDatalicense: Array<any> = [];
  brokerCommissions: Array<any> = [];
  finalSummaryDataForm: Array<any> = [];
  finalSummaryBrookerData: any;
  finalSummaryBrookerDataName: any;
  finalSummaryBrookerDataid: any;
  finalSumamryBrokerType: any;
  finalSumamryBrokersalesTrackingCode: any;
  finalSummaryBrookerDataBrokerType: any;
  editindex: any;
  editAdminIndex: any;
  showimagelogo = true;
  showdisclosureaggrement = true;
  showparentlogocondition: any;
  showparentformlogocondition = false;
  showparentdisclosurecondition = false;
  showsales_tracking_code = false;
  showsalestrackinCodeAuto = false;
  imagedisplaypdf: any;
  editbrokerlicensenumber: any;
  brokerlicensedetails: any;
  editbrokerlicensecoverage: any = '';
  editbrokerlicensestate: any;
  editbrokerlicenseexpirydate: any;
  editbrokerlicenseexpiryremainder: any;
  editbrokerlicenseshortName: any = '';
  configprovinceres: any;
  shortNameValue: any;
  enrollmentDates: any;
  imagedisplay: any;
  provincialHealthcareUrl: any;
  provincialZipcodes: any;
  SignupFormData: Array<any> = [];
  licensesInfo: Array<any> = [];
  brokersalesCodes: Array<any> = [];
  // brokersalesCodes: any;

  salestrackingCodeTableData: Array<any> = [];
  // saleTrackingCodearr:Array<any> = [];
  EOinsurenceInfo: any;
  provincelistid: any;
  insurancestate_id: any;
  insurancestatename: any;
  provinceshortName: any;
  fusebillId: any;
  licenseData: any;
  state_id: any;
  statename: any;
  public postalvalue: any;
  allplansArray: Array<any> = [];
  public plansIds = [];
  public plansError: boolean = false;
  public saveError: boolean = false;
  selectedBroker: any;
  displaylogo: any;
  brokerData: Array<any> = [];
  allBrokers: Array<any> = [];
  licenseCoverage: Array<any> = [];
  brokerType: Array<any> = [];
  formType: Array<any> = [];
  uploaddisclousreAggrement: any;
  productsArray: Array<any> = [];
  advisorGroupContact: Array<any> = [];
  pricingOptions: Array<any> = [];
  productsArrayList: Array<any> = [];
  uploadlogo: any;
  uploadFormlogo: any;
  showBusinessnumber: boolean = false;
  stc_generation: any;
  brokerTypeName: any;
  customForm: boolean = false;
  minDate = new Date();
  public invalidpostalcodeprivince: boolean = false;
  showAdvisorAdvData: boolean = false;
  adminData: any;
  addadminform = true;
  role = sessionStorage.getItem('role');
  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;

  brokerregform: FormGroup = new FormGroup({
    ParentbrokerName: new FormControl(''),
    brokerCount: new FormControl(''),
    brokerName: new FormControl(''),
    brokerType: new FormControl(''),
    businessnumber: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    primaryEmail: new FormControl(''),
    secondaryEmail: new FormControl(''),
    thirdEmail: new FormControl(''),
    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    postalCode: new FormControl(''),
    InsuranceName: new FormControl(''),
    policyNumber: new FormControl(''),
    certificateName: new FormControl(''),
    Insuranceexpiry: new FormControl(''),
    stc_generation: new FormControl(''),
    user_generated_stc: new FormControl(''),
    sales_tracking_code: new FormControl(''),
    parentlogo: new FormControl(''),
    parentdisclosure: new FormControl(''),
    logo: new FormControl(''),
    disclosureAgreement: new FormControl(''),
    signupForm: new FormControl(''),
    formName: new FormControl(''),
    formDescription: new FormControl(''),
    formLink: new FormControl(''),
  });

  brokerSharedregform: FormGroup = new FormGroup({
    ParentbrokerName: new FormControl(''),
    brokerName: new FormControl(''),
    brokerType: new FormControl(''),
    businessnumber: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    primaryEmail: new FormControl(''),
    secondaryEmail: new FormControl(''),
    thirdEmail: new FormControl(''),
    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    postalCode: new FormControl(''),


    // formName: new FormControl(''),
    // formDescription: new FormControl(''),
    // formLink: new FormControl(''),
  });

  adminform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    phoneNumber: new FormControl(''),
    email: new FormControl(''),
    role: new FormControl(''),
    roleName: new FormControl(''),
  });
  licenseform: FormGroup = new FormGroup({
    licenseNo: new FormControl(''),
    licenseCoverage: new FormControl(''),
    state: new FormControl(''),
    expiryDate: new FormControl(''),
    reminderMailDays: new FormControl(''),
  });
  eoform: FormGroup = new FormGroup({
    insurerName: new FormControl(''),
    policyNo: new FormControl(''),
    certificateNo: new FormControl(''),
    expiryDate: new FormControl(''),
  });

  formCreation: FormGroup = new FormGroup({

    Signupformtype: new FormControl(''),
    profileName: new FormControl(''),
    formName: new FormControl(''),
    formDescription: new FormControl(''),
    formlink: new FormControl(''),
    formapplylogo: new FormControl(''),
    formlogo: new FormControl(''),
    formplanLevels: new FormControl(''),
    formdisclosureAgreement: new FormControl(''),
    pricingOptions: new FormControl(''),
  });

  @ViewChild('formlogoyes')
  formlogoyes!: ElementRef<HTMLElement>;
  @ViewChild('formlogono')
  formlogono!: ElementRef<HTMLElement>;
  ShowOthers: boolean = false;
  prevSTC: any;
  showsalestrackingtable: boolean = false;
  salesTrackingCodeShares: Array<any> = [];
  noofbrokerscount = false;
  showSharedBrokerList = false;
  allBrokersUnique: Array<any> = [];
  salesTrackingInfo: any;
  brokerProfileslist: Array<any> = [];
  profileBasedOriginalId: any;
  licenseCoverageList: any;
  showSharedAdvisorData: boolean = false;
  sharedBrokerData: Array<any> = [];
  getsharedexisting: any;
  showsharedformData: boolean = false;
  brokerPercenatgeSum = 0;
  totalValue: any = 0;
  showsoleAdvisorDataResult: any;
  showfulldetails: boolean = false;
  showsubmitform: boolean = false;
  logoDisplayInList: any;
  public chart: any;
  private chartInfo: any;
  private labeldata: any[] = [];
  private realdata: any[] = [];
  private colordata: any[] = [];
  showSelectdAdvsiors: any[];
  brokerFormData: any[]; editFormDetails: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any
  showsignupformoptions: boolean = true;
  brokerDetails: any = {};
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  advisorData$: Observable<any>;
  brokerList: any = [];
  languageData$: Observable<any>;
  brokerFormConfigData: any = {};
  brokerFormConfigData$: Observable<any>;
  brokerConfigData: any = {};
  brokerConfigData$: Observable<any>;
  private destroy$ = new Subject<void>();
  showaddplans:boolean = false;
  showeditplans:boolean = false;
  selectedPlanLevels:any = [];
  showaddplanss: boolean = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    public elementRef: ElementRef,
    private _clipboardService: ClipboardService,
    private toastrService: ToastrService,
    private phoneNoFormat: PhoneFormatPipe,
    private salesTrackingFormaterFormatter: SalestrackingcodePipe,
    private fb: FormBuilder,
    public _LoaderService: LoaderService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private commonPatternsService: CommonPatternsService,
    private store: Store<{ advisorData: [], languageData: [], brokerFormConfigData: {}, brokerConfigData: {} }>
  ) {
    this.advisorData$ = store.select(selectAdvisorData);
    this.loading$ = store.select(selectAdvisorLoading);
    this.error$ = store.select(selectAdvisorError);
    this.languageData$ = store.select(selectLanguageData);
    this.brokerFormConfigData$ = store.select(selectBrokerFormConfigData);
    this.brokerConfigData$ = store.select(selectBrokerConfigData);
   }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  ngOnInit() {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Add Advisor');
    },100)
    // this.createChart();
    // $('#sumamryModel').modal('show');
    // $("#signupFormno").click()
    this.getLanguageTokens()
    sessionStorage.setItem('addlicenseformData', '');
    sessionStorage.setItem('addformDetails', '');
    this.todayDate = new Date();
    this.adminData = [];
    this.adminName = sessionStorage.getItem('adminName');
    this.dropdownList = [
      { item_id: 1, item_text: 'Mumbai' },
      { item_id: 2, item_text: 'Bangaluru' },
      { item_id: 3, item_text: 'Pune' },
      { item_id: 4, item_text: 'Navsari' },
      { item_id: 5, item_text: 'New Delhi' },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      groupBy: 'name',
    };
    this.dropdownSettings1 = {
      singleSelection: false,
      // closeDropDownOnSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All',
      itemsShowLimit: 4,
      allowSearchFilter: true,
    };
    this.brokerregform = this.formBuilder.group({
      ParentbrokerName: [''],
      brokerCount: [''],
      brokersName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(255),
        ],
      ],
      brokerType: ['', [Validators.required]],
      businessnumber: ['', [Validators.required]],
      streetAddress: ['', [Validators.required]],
      streetAddress2: [''],
      primaryPhone: [
        '',
        [
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      secondaryPhone: [
        '',
        [Validators.minLength(17), Validators.maxLength(17)],
      ],
      primaryEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),

        ],
      ],
      secondaryEmail: [
        '',
        [Validators.pattern(this.commonPatternsService.emailPattern)],
      ],
      thirdEmail: [
        '',
        [Validators.pattern(this.commonPatternsService.emailPattern)],
      ],
      country: ['canada', [Validators.required]],
      city: ['', [Validators.required]],
      Province: ['', [Validators.required]],
      postalCode: [
        '',
        Validators.compose([Validators.required, postalcodeValidator]),
      ],
      InsuranceName: [''],
      policyNumber: [''],
      certificateName: [''],
      Insuranceexpiry: [''],
      // stc_generation: ['', [Validators.required]],
      stc_generation: [''],

      user_generated_stc: [''],
      sales_tracking_code: [''],
      // parentlogo: ['', [Validators.required]],
      // parentdisclosure: ['', [Validators.required]],cd ..

      // logo: ['', [Validators.required]],
      // disclosureAgreement: ['', [Validators.required]],
      signupForm: ['false'],

      // brokerShare: ['false', [Validators.required]],
      brokerShare: [''],
      // brokerShare: ['false'],
      brokerStatus: ['true'],
      parentlogo: ['true'],
      parentdisclosure: ['true'],
      logo: [''],
      disclosureAgreement: [''],


    });
    this.brokerSharedregform = this.formBuilder.group({
      brokerStatus: [''],
      ParentbrokerName: [''],

      brokersName: [''],
      brokerType: [''],
      businessnumber: [''],
      streetAddress: [''],
      streetAddress2: [''],
      primaryPhone: [''],
      secondaryPhone: [''],
      primaryEmail: [''],
      secondaryEmail: [''],
      thirdEmail: [''],
      country: [''],
      city: [''],
      Province: [''],
      postalCode: [''],
    });
    this.adminform = this.formBuilder.group({
      firstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      phoneNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),
          this.emailValidation(),
        ],
      ],
      role: [null, [Validators.required]],
      roleName: [null],
    });

    this.eoform = this.formBuilder.group({
      insurerName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ],
      ],
      policyNo: ['', [Validators.required]],
      certificateNo: ['', [Validators.required]],
      expiryDate: ['', [Validators.required]],
    });

    this.licenseform = this.formBuilder.group({
      licenseNo: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
        ],
      ],
      licenseCoverage: ['', [Validators.required]],
      state: ['', [Validators.required]],
      expiryDate: ['', [Validators.required]],
      reminderMailDays: ['30', Validators.required],
    });

    this.formCreation = this.formBuilder.group({
      Signupformtype: [''],
      profileName: ['', [Validators.required]],
      formName: ['', [Validators.required]],
      formDescription: ['', [Validators.required]],
      formlink: [''],
      formapplylogo: [''],
      formlogo: [''],
      formdisclosureAgreement: [''],
      pricingOptions: [''],
    });

    this.id = this.route.snapshot.paramMap.get('id');

    // this.productsArray =[{"id":"3","name":"Classic Bronze"},{"id":"4","name":"Classic Silver"},{"id":"7","name":"All-In Bronze"},{"id":"8","name":"All-In Silver"}]

    this.formConfig();

    // this.brokersalesCodes.push({
    //   brokerId: '',
    //   percentage: '',
    // });

    // if (this.role == 'ADMINISTRATOR') {
    //   this.broker['user_generated_stc'].setValidators([Validators.required]);
    // } else {
    //   this.broker['user_generated_stc'].clearValidators();
    //   this.broker['user_generated_stc'].setValue(false);
    //   this.broker['user_generated_stc'].updateValueAndValidity();

    //   this.broker['sales_tracking_code'].clearValidators();
    //   this.broker['sales_tracking_code'].updateValueAndValidity();

    // };
    // this.initializeFormControls()
    this.store.dispatch(loadAdvisorData());
    this.advisorData$ = this.store.select(state => state.advisorData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.advisorData$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.advisorData == undefined || Object.keys(data.advisorData).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(this.brokerList.length>0){
        return;
      }
      this.brokerList = data.advisorData
      this.brokerList = this.brokerList.map((broker)=>{
        return{
          ...broker,
          published: !broker.published || broker.published == undefined || broker.published == null ? 'Inactive' : 'Active'
        }
      })
      } else {
        console.error('Observable returned undefined');
      }
    })
  }
  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "addAdvisor"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })

  }
  createChart(labeldata: any, realdata: any) {

    console.log(labeldata)
    console.log(realdata)
    if (this.chart) {
      this.chart.clear();
      this.chart.destroy();
    }
    this.chart = new Chart("MyChart", {
      type: 'pie', //this denotes tha type of chart

      data: {
        labels: labeldata,
        datasets: [
          {
            label: 'Commission',
            data: realdata,
            backgroundColor: [
              'blue',
              'pink',
              'green',
              'yellow',
              'orange',
              'red',
            ],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        aspectRatio: 2.5
      }

    });

  }
  public isParentsGreaterThanOne(groups: any): boolean {
    // console.log(Object.keys(groups), Object.keys(groups).length > 1)
    return groups && Object.keys(groups).length > 1;
  }

  public showPricing = false;

  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }

  getColorForPlans(published, restricted, name?, plan?) {
    // console.log(published, restricted, name, plan)
    const pubStatus = { 0: false, 1: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }

  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }


  initializePlansArray(
    pArray: any,
    checked: boolean,
    disabled: boolean,
    type?: string
  ) {
    this.allplansArray = [];

    pArray.forEach((product) => {
      let obj = {
        packageCheckbox:
          type === 'EXECUTIVE' && product.name === 'Private Health'
            ? true
            : checked,
        packageId: product.id,
        packageName: product.name,
        disabled: disabled,
      };

      Object.keys(product.parents).forEach((plan: any) => {
        product.parents[plan].forEach((p) => {
          obj[p.name] = {
            planCheckbox:
              type === 'EXECUTIVE' && product.name === 'Private Health'
                ? true
                : checked,
            planId: p.id,
            parentId: p.parentId,
            planName: p.name,
            disabled: disabled,
          };
          obj[plan] = {
            checked: checked,
            disabled: disabled,
            isParent: true,
            id: p.parentId || '',
          };
        });
      });

      this.allplansArray[product.name] = obj;
    });
    console.log({ plansArray: this.allplansArray });
  }

  changePackageCheckedValues(productName: any, productId: any, bool: boolean) {
    this.allplansArray[productName]['packageCheckbox'] = bool;
    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object') {
        this.allplansArray[productName][p]['planCheckbox'] = bool;
      }
    });

    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (
        typeof this.allplansArray[productName][p] === 'object' &&
        this.allplansArray[productName][p].isParent
      ) {
        this.allplansArray[productName][p].checked = bool;
      }
    });
    console.log({ plansArray: this.allplansArray });
  }

  checkForClassic() {
    let flag = 0;

    Object.keys(this.allplansArray).forEach((pack: any) => {
      if (this.allplansArray[pack].packageId == 1) {
        Object.keys(this.allplansArray[pack]).forEach((p) => {
          if (
            typeof this.allplansArray[pack][p] === 'object' &&
            p.includes('Classic') &&
            this.allplansArray[pack][p]['parentId'] &&
            this.allplansArray[pack][p]['planCheckbox'] === true
          ) {
            flag = flag + 1;
          }
        });
      }
    });

    if (flag >= 1) {
      this.showPricing = true;
    } else {
      this.showPricing = false;
    }
  }

  toggleAllPlans(productName: any, productId: any, event: any) {
    console.log(productName, productId, event.target.checked);

    if (event.target.checked) {
      this.plansError = false;
      this.changePackageCheckedValues(productName, productId, true);
    } else {
      this.changePackageCheckedValues(productName, productId, false);
    }

    console.log({ plansArray: this.allplansArray });
    this.checkForClassic();
  }

  checkForAllPlansChecked(productName, planKey: any, parentId) {
    let planFlag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (
        typeof this.allplansArray[productName][p] === 'object' &&
        this.allplansArray[productName][p]['parentId'] === parentId &&
        this.allplansArray[productName][p]['planCheckbox'] === false
      );
    });
    this.allplansArray[productName][planKey].checked = !planFlag;

    let flag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (
        typeof this.allplansArray[productName][p] === 'object' &&
        this.allplansArray[productName][p]['parentId'] != 'null' &&
        this.allplansArray[productName][p]['planCheckbox'] === false
      );
    });

    this.allplansArray[productName].packageCheckbox = !flag;

    console.log({ plansAyyay: this.allplansArray });
  }

  changePlanCheckedValues(productName: any, planKey: any, parentId: any) {
    this.allplansArray[productName].packageCheckbox = false;
    this.allplansArray[productName][planKey].checked = false;
    this.checkForAllPlansChecked(productName, planKey, parentId);
    this.checkForClassic();
  }

  planCheckbox(
    productName: any,
    planKey: any,
    parentId: any,
    planName: any,
    planId: any,
    event: any
  ) {
    if (event.target.checked) {
      this.plansError = false;
      this.allplansArray[productName][planName].planCheckbox = true;

      this.changePlanCheckedValues(productName, planKey, parentId);
      if (planName.includes("La Vie")) {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector(`#plancheck792`)
        const plan: any = dom.querySelector("#planCheckbox18");
        setTimeout(() => {
          plan.click()
          this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
        }, 1000);




      }
    } else {
      this.allplansArray[productName][planName].planCheckbox = false;

      this.changePlanCheckedValues(productName, planKey, parentId);
    }
    this.checkForAllPlansChecked(productName, planKey, parentId);
    this.checkForClassic();
  }

  planKeyCheckbox(productName: any, planKey: any, parentId: any, event: any) {
    if (event.target.checked) {
      this.plansError = false;

      this.allplansArray[productName][planKey].checked = true;
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (
          typeof this.allplansArray[productName][p] === 'object' &&
          typeof this.allplansArray[productName][p].hasOwnProperty('parentId')
        ) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['planCheckbox'] = true;
            console.log(
              this.allplansArray[productName][p]['parentId'] == parentId,
              this.allplansArray[productName][p]['planCheckbox']
            );
          }
        }
      });
    } else {
      this.allplansArray[productName][planKey].checked = false;
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (
          typeof this.allplansArray[productName][p] === 'object' &&
          typeof this.allplansArray[productName][p].hasOwnProperty('parentId')
        ) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['planCheckbox'] = false;
          }
        }
      });
    }
    console.log({ plansArray: this.allplansArray });
    this.checkForAllPlansChecked(productName, planKey, parentId);
    this.checkForClassic();
  }

  get broker() {
    return this.brokerregform.controls;
  }
  get brokerShared() {
    return this.brokerSharedregform.controls;


  }
  ngAfterViewInit() {
    console.log('23456yhjkjkkkkkkkkkkkkkkkkk');
    this.licenseform.get('licenseCoverage').setValue('');
    this.licenseform.get('licenseCoverage').updateValueAndValidity();
    this.licenseform.get('state').setValue('');
    this.licenseform.get('state').updateValueAndValidity();
    this.formCreation.get('Signupformtype').setValue('');
    this.formCreation.get('Signupformtype').updateValueAndValidity();
  }
  get grpcontact() {
    return this.adminform.controls;
  }
  validateEmail(email: string) {
    var result = '';
    var splitEmail;
    //check for @
    if (email.indexOf('@') > -1) {
      splitEmail = email.split('@');
      if (splitEmail[0].length <= 64) {
        if (/[A-Za-z0-9]/i.test(splitEmail[0])) {
        } else {
        }
      } else {
        result = 'Recipient name Exceeds 64 characters';
        return result;
      }
    } else {
      result = 'Ampersand not Found';
      return result;
    }
  }

  get f() {
    return this.licenseform.controls;
  }
  get eo() {
    return this.eoform.controls;
  }
  get form() {
    return this.formCreation.controls;
  }

  checkbrokertype(brokerType) {
    this.brokerTypeName = brokerType;
    console.log(brokerType);
    this.brokerList = {
      ...this.brokerList,
      brokerType:brokerType,
    }
    if (brokerType == 'BROKERAGE') {
      this.showBusinessnumber = true;
      this.broker['businessnumber'].setValidators([Validators.required]);

      this.broker['businessnumber'].updateValueAndValidity();

      this.stc_generation = 'false';
    } else {
      this.showBusinessnumber = false;

      this.stc_generation = 'true';

      this.broker['businessnumber'].clearValidators();
      this.broker['businessnumber'].reset();
      this.broker['businessnumber'].updateValueAndValidity();
    }
  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

    // /^\d{2}[./-]\d{2}[./-]\d{4}$/
  }

  alphaNumarics(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (event.currentTarget.value.length == 0) {
      //for first latter not allow space
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 32
      )
        return true;
      else return false;
    }
  }
  closesharedmodel() {
    const preservedValues = {
      brokerCount: this.brokerregform.get('brokerCount')?.value,

      brokerShare: this.brokerregform.get('brokerShare')?.value,
      brokerStatus: this.brokerregform.get('brokerStatus')?.value

    };
    this.brokerregform.reset(preservedValues);
    this.adminform.reset();
    this.licenseform.reset();
    this.formCreation.reset();
    this.adminData = []
    this.addlicenseformData = []
    this.EOinsurenceInfo = '';
    this.addadminform = true
    this.showaddadmin = false
    this.addlicenseform = true
    this.addlicenseformtable = false
    this.addEOform = true
    this.showaddEOdetails = false
    $('#BrokerSharedNewDetails').hide()

  }
  addadmin() {
    if (this.adminform.invalid) {
      console.log(this.adminform);
      this.adminform.markAllAsTouched();
      return;
    }

    console.log(JSON.stringify(this.adminform.value, null, 2));
    let obj = {
      firstName: this.capitalize(this.adminform.value.firstName),
      lastName: this.capitalize(this.adminform.value.lastName),
      phoneNumber: this.adminform.value.phoneNumber,
      email: this.adminform.value.email,
      role: this.adminform.value.role,
    };
    if (obj.role == 'ADVISOR_OTHERS') {
      obj['roleName'] = this.adminform.value.roleName;
    } else {
      obj['roleName'] = "";

    }



    console.log(obj)
    this.adminData.push(obj);

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    this.ShowOthers = false;

    $('#basicModaladdgrpcontact').modal('hide');
    Swal.fire({
      title: 'Info',
      text: 'Group Admin Added Successfully',
    });
  }

  clearGroupContactData() {
    this.adminform.reset();
  }
  closeBrokerDetailsModel() {
    $("#BrokerSharedNewDetails").hide()

  }
  multiSelectAdvsiorSelect(event: any) {
    //convert number into string?
    console.log(event);
    // this.multiSelectProviance.push(event.id);
    // this.multiSelectProviancenames.push(event)

    this.brokersalesCodes.push({
      brokerId: event.id,
      brokerName: event.name,
      commission: '',
    });

    this.showsharedExistingButton = true
    this.showsalestrackinCodeAuto = true;

    console.log(this.brokersalesCodes)
    // $("#BrokerSharedNewDetails").hide()


    if (this.brokersalesCodes.length == this.broker['brokerCount'].value) {
      this.showSharedBrokerList = false
    }
    else {
      this.showSharedBrokerList = true
    }
  }
  closemultiSelectAdvisorList() {
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
      $("#BrokerSharedNewDetails").hide()
    }
  }
  multiSelectAdvisorSelectAll(event: any) {
    console.log(event);
    this.brokersalesCodes = [];
    // this.multiSelectProviancenames = [];
    event.forEach((data: any) => {
      // console.log(proviance)
      // this.multiSelectProviance.push(proviance.id);
      this.brokersalesCodes.push({ "brokerId": data.id, "brokerName": data.name, "commission": '' });


    });
    console.log(this.brokersalesCodes)

    this.closemultiSelectAdvisorList();
  }




  multiSelectAdvisorItemDeSelect(event: any) {
    console.log(event);
    let indexOf = this.brokersalesCodes.indexOf(event.id);
    this.brokersalesCodes.splice(indexOf, 1);
    // this.multiSelectProviancenames.splice(indexOf, 1);

    console.log(this.brokersalesCodes);

    if (this.brokersalesCodes.length == 0) {
      this.showsharedExistingButton = false

    }
  }
  multiSelectAdvisorDeSelectAll(event: any) {
    console.log(event);
    this.brokersalesCodes = [];
    // this.multiSelectProviancenames = [];
    console.log(this.brokersalesCodes);
    this.showsharedExistingButton = false
  }

  addadminShared() {
    if (this.adminform.invalid) {
      console.log(this.adminform);
      this.adminform.markAllAsTouched();
      return;
    }

    console.log(JSON.stringify(this.adminform.value, null, 2));
    let obj = {
      firstName: this.capitalize(this.adminform.value.firstName),
      lastName: this.capitalize(this.adminform.value.lastName),
      phoneNumber: this.adminform.value.phoneNumber,
      email: this.adminform.value.email,
      role: this.adminform.value.role,
    };
    if (obj.role == 'ADVISOR_OTHERS') {
      obj['roleName'] = this.adminform.value.roleName;
    } else {
      obj['roleName'] = "";

    }

    this.adminData.push(obj);

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    this.ShowOthers = false;

    $('#basicModaladdgrpcontactShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');
    Swal.fire({
      title: 'Info',
      text: 'Group Admin Added Successfully',
    });
  }
  deleteadmin(index: any) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this Group Contact?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const Data = this.adminData;
        const removed = Data.splice(index, 1);

        if (this.adminData.length == 0) {
          this.addadminform = true;
          this.showaddadmin = false;
        } else {
          this.addadminform = false;
          this.showaddadmin = true;
        }
      }
    });
  }

  deleteEO(index: any) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this EO?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.EOinsurenceInfo = '';
        this.eoform.reset();

        if (this.EOinsurenceInfo.length == 0) {
          this.addEOform = true;
          this.showaddEOdetails = false;
        } else {
          this.addEOform = false;
          this.showaddEOdetails = true;
        }
      }
    });
  }

  editadmin(admin: any, index: any) {
    console.log(admin);
    this.ShowOthers = admin.role == 'ADVISOR_OTHERS' ? true : false;
    console.log(this.adminform);
    this.editAdminIndex = index;
    this.adminform.patchValue(admin);
  }

  editadminShared(admin: any, index: any) {
    console.log(admin);
    this.ShowOthers = admin.role == 'ADVISOR_OTHERS' ? true : false;
    console.log(this.adminform);
    this.editAdminIndex = index;
    this.adminform.patchValue(admin);
    $('#BrokerSharedNewDetails').hide();

  }

  emailValidation() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // console.log({ control: control.value });

      let email: boolean;
      // console.log(this.editAdminIndex);
      for (const i in this.adminData) {
        if (
          (this.editAdminIndex != null || this.editAdminIndex != '') &&
          this.editAdminIndex === parseInt(i)
        ) {
          console.log(
            this.editAdminIndex == parseInt(i),
            i,
            this.editAdminIndex
          );
          continue;
        }
        console.log(this.adminData[i].email, control.value);
        email = this.adminData[i].email === control.value;
        if (email) break;
      }
      if (email) {
        return { emailExist: true };
      }
      return null;
    };
  }

  editEO() {
    this.EOinsurenceInfo.expiryDate = moment(
      this.EOinsurenceInfo.expiryDate
    ).format('MM-DD-YYYY');

    console.log(this.EOinsurenceInfo);
    this.eoform.patchValue(this.EOinsurenceInfo);
  }

  editEOShared() {
    this.EOinsurenceInfo.expiryDate = moment(
      this.EOinsurenceInfo.expiryDate
    ).format('MM-DD-YYYY');

    console.log(this.EOinsurenceInfo);
    this.eoform.patchValue(this.EOinsurenceInfo);

    $('#BrokerSharedNewDetails').hide();
  }

  checkEmailValidation(e: any) {
    // console.log('asasassasasa');
    let val = e.currentTarget.value;
    let notAlloewdSecvence = [
      '"',
      '#',
      '$',
      '%',
      '(',
      ')',
      '.',
      ',',
      ':',
      ';',
      '<',
      '>',
      '@',
      '[',
      ']',
    ];
    if (e.key == val.charAt(val.length - 1)) {
      if (notAlloewdSecvence.includes(val.charAt(val.length - 1))) {
        return false;
      }
    } else {
      if (val.length != 0) {
      } else {
      }
      return true;
    }
  }

  editEOSubmit() {
    if (this.eoform.invalid) {
      console.log(this.eoform);
      return;
    }
    console.log(JSON.stringify(this.eoform.value, null, 2));

    this.EOinsurenceInfo = this.eoform.value;

    this.eoform.reset();
    this.showaddEOdetails = true;
    this.addEOform = false;
    $('#basicModaleoedit').modal('hide');
    // $('#basicModal1').modal('hide');
  }

  editEOSharedSubmit() {
    if (this.eoform.invalid) {
      console.log(this.eoform);
      return;
    }
    console.log(JSON.stringify(this.eoform.value, null, 2));

    this.EOinsurenceInfo = this.eoform.value;

    this.eoform.reset();
    this.showaddEOdetails = true;
    this.addEOform = false;
    $('#basicModaleoeditShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');
    // $('#basicModal1').modal('hide');
  }
  editadminSubmit() {
    if (this.adminform.invalid) {
      this.adminform.markAllAsTouched();
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    // let obj = {
    //   adminfirstname: this.capitalize(this.adminform.value.adminfirstname),
    //   lastName: this.capitalize(this.adminform.value.adminlastname),
    //   phoneNum: this.adminform.value.adminphone,
    //   email: this.adminform.value.adminemail,
    //   role: this.adminform.value.role,
    // };

    this.adminData[this.editAdminIndex] = this.adminform.value;

    console.log(this.adminData)

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    this.editAdminIndex = null;
    $('#basicModaleditgroupcontact').modal('hide');

    Swal.fire({
      title: 'Info',
      text: 'Group Admin Updated Successfully',
    });
    // $('#basicModal1').modal('hide');
  }
  editadminSubmitShared() {
    if (this.adminform.invalid) {
      this.adminform.markAllAsTouched();
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    // let obj = {
    //   adminfirstname: this.capitalize(this.adminform.value.adminfirstname),
    //   lastName: this.capitalize(this.adminform.value.adminlastname),
    //   phoneNum: this.adminform.value.adminphone,
    //   email: this.adminform.value.adminemail,
    //   role: this.adminform.value.role,
    // };

    this.adminData[this.editAdminIndex] = this.adminform.value;

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    this.editAdminIndex = null;
    $('#basicModaleditgroupcontactShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');

    Swal.fire({
      title: 'Info',
      text: 'Group Admin Updated Successfully',
    });
    // $('#basicModal1').modal('hide');
  }
  hidegrpadmindetails() {
    this.adminform.reset();
    this.allplansArray = [];
    this.ShowOthers = false;
    $('#basicModaleditgroupcontactShared').modal('hide');

    $('#BrokerSharedNewDetails').modal('show');

  }
  hidegrpadmindetailsSharedEO() {
    // this.adminform.reset();
    // this.allplansArray = [];
    // this.ShowOthers = false;
    $('#basicModaleoeditShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');

  }
  hidegrpadmindetailsShared() {
    this.adminform.reset();
    this.allplansArray = [];
    this.ShowOthers = false;
    $('#basicModaleditgroupcontactShared').modal('hide');
    $('#basicModaladdgrpcontactShared').modal('hide');

    $('#BrokerSharedNewDetails').modal('show');

  }

  hidegrpadmindetailsShared1() {
    this.adminform.reset();
    this.allplansArray = [];
    this.ShowOthers = false;
    $('#BrokerSharedNewDetails').hide();




  }



  addEOformDetails() {
    if (this.eoform.invalid) {
      console.log(this.eoform.value);
      return;
    }
    console.log(JSON.stringify(this.eoform.value, null, 2));

    let obj = {
      insurerName: this.capitalize(this.eoform.value.insurerName),
      certificateNo: this.eoform.value.certificateNo,
      policyNo: this.eoform.value.policyNo,
      expiryDate:
        this.datePipe.transform(
          this.eoform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
    };
    this.EOinsurenceInfo = obj;

    console.log(this.EOinsurenceInfo)

    this.addEOform = false;
    this.showaddEOdetails = true;
    this.eoform.reset();

    $('#basicModal1').modal('hide');
  }


  brokerAdd() {
    $("#BrokerSharedNewDetails").show()
    this.brokerregform.get('ParentbrokerName').setValue('');
    setTimeout(() => {
      this.showSelectdAdvsiors = [];
      this.allBrokersUnique.map((data) => {
        console.log(data)
        console.log(this.brokersalesCodes)

        this.brokersalesCodes.forEach((product) => {

          if (data.id == product.brokerId) {
            this.showSelectdAdvsiors.push(data)

          }


        })

        console.log("showmulti", this.showSelectdAdvsiors)

      });

      this.broker['ParentbrokerName'].setValue(this.showSelectdAdvsiors);
      console.log(this.broker['ParentbrokerName'])

    }, 1000);

  }

  closeBrokerAdd() {
    $("#BrokerSharedNewDetails").hide()

  }
  addnewlicense() {
    this.licenseform.reset();
    this.licenseform.get('licenseCoverage').setValue('');
    this.licenseform.get('licenseCoverage').updateValueAndValidity();
    this.licenseform.get('state').setValue('');
    this.licenseform.get('state').updateValueAndValidity();
  }
  addnewlicenseShared() {
    this.licenseform.reset();
    this.licenseform.get('licenseCoverage').setValue('');
    this.licenseform.get('licenseCoverage').updateValueAndValidity();
    this.licenseform.get('state').setValue('');
    this.licenseform.get('state').updateValueAndValidity();
    $('#BrokerSharedNewDetails').hide()
  }
  editadvisorlicenseDetails(e, i, broker) {
    console.log(broker);

    this.brokerlicensedetails = broker;
    this.editindex = i;
    this.editbrokerlicensenumber = broker.licenseNo;
    this.editbrokerlicensecoverage = broker.licenseCoverage;
    this.editbrokerlicensestate = broker.provinces_name;
    this.editbrokerlicenseexpirydate =
      this.datePipe.transform(broker.expiryDate, 'MM-dd-yyyy') || '';
    this.editbrokerlicenseexpiryremainder = broker.reminderMailDays;
    this.editbrokerlicenseshortName = broker.provinceshortName;

    // this.isEditable =false;
    // this.enableEditIndex = i;
    // console.log(i, e);
    // this.addlicenseformData = JSON.parse(sessionStorage.getItem('addlicenseformData'))
  }

  editadvisorlicenseDetailsShared(e, i, broker) {
    console.log(broker);

    this.brokerlicensedetails = broker;
    this.editindex = i;
    this.editbrokerlicensenumber = broker.licenseNo;
    this.editbrokerlicensecoverage = broker.licenseCoverage;
    this.editbrokerlicensestate = broker.provinces_name;
    this.editbrokerlicenseexpirydate =
      this.datePipe.transform(broker.expiryDate, 'MM-dd-yyyy') || '';
    this.editbrokerlicenseexpiryremainder = broker.reminderMailDays;
    this.editbrokerlicenseshortName = broker.provinceshortName;
    $("#BrokerSharedNewDetails").hide()
    // this.isEditable =false;
    // this.enableEditIndex = i;
    // console.log(i, e);
    // this.addlicenseformData = JSON.parse(sessionStorage.getItem('addlicenseformData'))
  }


  initializeCustomizePlansArray(formLevels: any) {
    Object.keys(this.allplansArray).forEach((product) => {
      // console.log({ product })
      Object.keys(this.allplansArray[product]).forEach((plan) => {
        // console.log(this.allplansArray[product][plan])

        if (
          typeof this.allplansArray[product][plan] == 'object' &&
          this.allplansArray[product][plan]['planId'] != null
        ) {
          // console.log(product, plan, this.allplansArray[product], this.allplansArray[product][plan])

          this.allplansArray[product][plan]['planCheckbox'] =
            formLevels.includes(this.allplansArray[product][plan]['planId']);
        }
      });
    });

    Object.keys(this.allplansArray).forEach((product) => {
      Object.keys(this.allplansArray[product]).forEach((plan) => {
        if (
          typeof this.allplansArray[product][plan] == 'object' &&
          this.allplansArray[product][plan]['isParent'] == true
        ) {
          this.changePlanCheckedValues(
            product,
            plan,
            this.allplansArray[product][plan].id
          );
        }
      });
    });
    this.checkForClassic();
    console.log({ plansArrayCustomise: this.allplansArray });
  }

  editadvisorformDetails1(e, i, form) {
    // this.isEditableForm =false;
    // this.enableEditIndexForm = i;
    // console.log(i, e);
    // this.addformDetails = JSON.parse(sessionStorage.getItem('addformDetails'))

    $('#sumamryModel').modal('hide');


    console.log({ form });
    this.editindex = i;
    this.planLevels = form.planLevels;
    this.editFormType = 'CUSTOM';
    this.signUpFormType = 'CUSTOM';
    this.editFormName = form.name;
    this.editFormProfile = form.profile
    this.editFormDescription = form.description;
    this.editFormlink = '';
    this.editFormlogo = form.logo;
    this.editFormPricingOptions = form.productType;
    this.editFormdisplaylogo = form.logodisplay;
    this.editFormDisclousreAggrement = '';

    if (form.logo) {
      var reader = new FileReader();
      reader.readAsDataURL(form.logo);

      reader.onload = (_event) => {
        this.editFormdisplaylogo = reader.result;
      };
    }

    // this.planLevels = form.planLevels;
    // this.productsArrayList.map((product) => {
    //   if (form.planLevels.includes(product.id)) {
    //     this.planLevels.push(product.name)
    //   }
    // })

    // console.log(form, this.editFormPricingOptions)

    // if (this.editFormType === 'REGULAR') {
    //   this.initializePlansArray(this.productsArray, true, true, 'REGULAR')
    // }
    // if (this.editFormType === 'EXECUTIVE') {
    //   this.initializePlansArray(this.productsArray, false, true, 'EXECUTIVE')
    // }
    if (this.editFormType === 'CUSTOM') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM');
    }

    if (
      form.planLevels &&
      form.planLevels.length &&
      this.editFormType == 'CUSTOM'
    ) {
      this.customForm = true;
      this.initializeCustomizePlansArray(form.planLevels);
      this.selectedItems = this.planLevels;
      this.checkForClassic();
      // this.form['formplanLevels'].setValidators([Validators.required]);;

      // this.form['formplanLevels'].updateValueAndValidity();
    } else {
      this.customForm = false;

      // this.form['formplanLevels'].clearValidators();

      // this.form['formplanLevels'].updateValueAndValidity();
    }

    if (form.logo.name && form.logo.name.length) {
      this.showparentformlogocondition = true;
      let el: HTMLElement = this.formlogono.nativeElement;
      el.click();
    } else {
      this.showparentformlogocondition = false;
      let el: HTMLElement = this.formlogoyes.nativeElement;
      el.click();
    }

    this.showPlans = true;
  }

  editadvisorformDetails(e, i, form) {
    // this.isEditableForm =false;
    // this.enableEditIndexForm = i;
    // console.log(i, e);
    // this.addformDetails = JSON.parse(sessionStorage.getItem('addformDetails'))

    // alert(form.matchedProfile.name)
    $('#sumamryModel').modal('hide');
    console.log(form)
    this.editFormDetails = form

    console.log(form, form.filterProductType)
    this.editindex = i;
    this.editFormType = form.formType;
    this.editFormProfile = form.matchedProfile.originalBrokerId;
    this.editFormName = form.name;
    this.editFormDescription = form.description;
    this.editFormlink = "";
    this.editFormlogo = form.logo || "/assets/img/logo.png";
    this.editFormDisclousreAggrement = "";
    this.planLevels = form.planLevels
    this.editFormPricingOptions = form.filterProductType;





    if (this.editFormType === 'REGULAR') {
      this.initializePlansArray(this.productsArray, true, false, 'REGULAR')
    }
    if (this.editFormType === 'EXECUTIVE') {
      this.initializePlansArray(this.productsArray, false, false, 'EXECUTIVE')
    }
    if (this.editFormType === 'CUSTOM') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')

    }
    console.log(form)
    console.log(form.signupFormPlanLevels)
    if (form.signupFormPlanLevels) {

      if (form.formType == 'CUSTOM') {

        this.customForm = true

        const plansSelected = form.signupFormPlanLevels.map((plan) => (
          plan.planLevelId
        ))
        this.selectedPlanLevels = plansSelected;
        console.log({ plansSelected })

        this.selectedItems = form.planLevels
        this.initializeCustomizePlansArray(plansSelected)

        // this.form['formplanLevels'].setValidators([Validators.required]);;

        // this.form['formplanLevels'].updateValueAndValidity();
      }
      else {
        this.customForm = false
        // this.form['formplanLevels'].clearValidators();

        // this.form['formplanLevels'].updateValueAndValidity();
      }


    }
    else {

      this.customForm = false
      // this.form['formplanLevels'].clearValidators();

      // this.form['formplanLevels'].updateValueAndValidity();
    }
    this.showPlans = true
    this.showaddplans = false;
    this.showeditplans = true;
    $('#basicModalFormedit').modal('show');
  }

  editFormSubmit() {
    // this.getPlansId()

    this.plansIds =  JSON.parse(sessionStorage.getItem('plansIds') ?? '[]')
    console.log('this.plansIds',this.plansIds);

    console.log(this.formCreation.controls);
    this.plansIds.length <= 0 ? this.plansError = true : this.plansError = false

    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      console.log(this.formCreation.value, this.plansIds.length);
      return;
    }
    // console.log(JSON.stringify(this.formCreation.value, null, 2));

    var accessToken = sessionStorage.getItem('accessToken');


    var saveAdvisorForm = '/api/ap/broker/' + this.editFormDetails.brokerId + '/form/' + this.editFormDetails.id + '/modify';


    let logoDetails = '';
    if (this.uploadFormlogo) {
      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }


    let image;

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {

        image = reader.result
        this.editFormlogo = image
      };
      this.showPlans = false
    }
    // if (this.formCreation.value.formplanLevels && this.formCreation.value.formplanLevels.length > 0) {
    //   let formplansData = this.formCreation.value.formplanLevels

    //   for (let i = 0; i < formplansData.length; i++) {
    //     this.fromplansarry.push(formplansData[i].id)
    //   }
    // }

    let obj = {
      formType: 'CUSTOM',
      name: this.capitalize(this.formCreation.value.formName),
      description: this.capitalize(this.formCreation.value.formDescription),
      link: "",
      planLevels: this.plansIds || [],
      logo: logoDetails || "",
      formDisclosureAgreement: "",
      productType: this.formCreation.value.pricingOptions || "GIG",

    };


    console.log(obj)

    var form = new FormData();
    form.append("newType", 'CUSTOM');
    form.append("name", this.capitalize(this.formCreation.value.formName));
    form.append("description", this.capitalize(this.formCreation.value.formDescription));
    form.append("nameOrId", "false");
    form.append("planlevel", JSON.stringify(obj.planLevels) || "[]");
    form.append("logo", logoDetails || "");
    form.append("productType", this.formCreation.value.pricingOptions || "GIG");



    var requestOptions: any = {
      method: 'POST',

      body: form,

      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };

    console.log(requestOptions)

    fetch(environment.apiUrl + saveAdvisorForm, requestOptions)
      .then((response) => response.text())

      .then((response: any) => {
        this.uploadFormlogo = ''
        this.closePlans();

        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })

        this.getBrokerDetails()
        // this.getServiceWorkerDetails()
        this.addformDetails[this.editindex] = obj;

        this.formCreation.reset();
        this.showFormsDetails = true;
        this.showaddform = false;
        sessionStorage.setItem(
          'addformDetails',
          JSON.stringify(this.addformDetails)
        );
        $('#basicModalFormedit').modal('hide');

        $('#sumamryModel').modal('show');
      })

    this.plansIds = []
  }
  saveLicense(license: any, index: number) {
    this.licenseform.markAllAsTouched();

    let obj = {
      provinceId: this.insurancestate_id,
      provinceName: this.insurancestatename,
      provinceStaxbillId: this.fusebillId,
      expiryDate:
        this.datePipe.transform(license.expiry_date, 'MM-dd-yyyy') || '',
      reminderMailDays: parseInt(license.reminder_email),
      licenseNo: license.license_num,
      licenseCoverage: license.license_coverage,
      provinceshortName: license.provinceshortName
    };

    this.addlicenseformData[index] = obj;
    // this.addlicenseformData.push(obj);
    this.isEditable = true;
    this.enableEditIndex = null;
    sessionStorage.setItem(
      'addlicenseformData',
      JSON.stringify(this.addlicenseformData)
    );
  }
  cancellicneseEdit(e, i) {
    this.isEditable = true;
    this.enableEditIndex = null;
    this.addlicenseformData = JSON.parse(
      sessionStorage.getItem('addlicenseformData')
    );
  }

  cancelFormEdit(e, i) {
    this.isEditableForm = true;
    this.enableEditIndexForm = null;
    this.addformDetails = JSON.parse(sessionStorage.getItem('addformDetails'));
  }

  saveForm(form: any, index: number) {
    this.getPlansId();

    let obj = {
      formType: form.formType,
      name: this.capitalize(form.name),
      description: this.capitalize(form.description),
      profile: form.profile,
      link: '',
      planLevels: form.formType === 'CUSTOM' ? this.plansIds : [],
      logo: form.logo || '',
      singleSku: true,
      productType: form.pricingOptions || 'GIG',
      // formDisclosureAgreement: this.licenseform.value.formdisclosureAgreement || "",
    };

    this.addformDetails[index] = obj;
    // this.addlicenseformData.push(obj);
    this.isEditableForm = true;
    this.enableEditIndexForm = null;

    console.log(this.addformDetails);
    sessionStorage.setItem(
      'addformDetails',
      JSON.stringify(this.addformDetails)
    );
  }

  deletelicense(license: any, i: number) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this License?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addlicenseformData.splice(i, 1);

        if (this.addlicenseformData.length == 0) {
          this.addlicenseform = true;
          this.addlicenseformtable = false;
        } else {
          this.addlicenseform = false;
          this.addlicenseformtable = true;
        }
        sessionStorage.setItem(
          'addlicenseformData',
          JSON.stringify(this.addlicenseformData)
        );
      }
    });
  }

  deleteForm12(license: any, i: number) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this form?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addformDetails.splice(i, 1);

        if (this.addformDetails.length == 0) {
          this.showaddform = true;
          this.showPlans = true;
          this.initializePlansArray(this.productsArray, false, false, 'CUSTOM');
          this.showFormsDetails = false;
        } else {
          this.showaddform = false;
          this.showFormsDetails = true;
        }

        sessionStorage.setItem(
          'addformDetails',
          JSON.stringify(this.addformDetails)
        );
      }
    });
  }
  deleteForm(from: any, i: number) {


    // console.log(from)
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this form?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // this.brokerFormData.splice(i, 1);
        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBrokerForm = '/api/ap/broker/form/' + from.id + '';

        this.http
          .delete(environment.apiUrl + deleteBrokerForm, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {

                this.getBrokerDetails()
                //this.getServiceWorkerDetails()
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })

              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
        if (this.brokerFormData.length == 0) {
          this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
          this.showaddform = true;
          this.showFormsDetails = false;
          this.showPlans = true;
          this.showsignupformoptions = true
        }
        else {
          this.showaddform = false;
          this.showFormsDetails = true;
          this.showPlans = false;
        }
      }
    })
  }

  public noofbrokersales(event) {
    let count = event.target.value;

    // if (count < this.oldvaluenumber) {
    //   this.brokersalesCodes.removeAt(count);
    //   this.oldvaluenumber--;
    // } else {
    //   this.brokersalesCodes.push(this.initChildDetails());
    //   this.oldvaluenumber++;
    // }
    this.addRow();
  }
  addRow() {
    // this.basicTiersCount++;
    this.brokersalesCodes.push({
      brokerId: '',
      commission: '',
    });
  }


  deleteRow(index: number, dynamic: any) {
    // if (this.brokersalesCodes.length == 1) {
    //   Swal.fire({
    //     title: 'Warning',
    //     text: "Can't delete the row when there is only one row",
    //   });
    //   return false;
    // } else {
    // this.allBrokers.push(this.brokersalesCodes.splice(index, 1));
    this.brokersalesCodes.splice(index, 1);
    const totalValue = this.brokersalesCodes.reduce((sum, item) => sum + +item.commission, 0);
    this.totalValue = totalValue

    if (this.brokersalesCodes.length == this.broker['brokerCount'].value) {
      this.showSharedBrokerList = false
      this.showsharedformData = true
      // this.brokerregform.get('brokerCount').setValue(this.brokersalesCodes.length);
    }
    else {
      if (this.brokersalesCodes.length == 0) {
        this.showsalestrackinCodeAuto = false
      }
      this.showSharedBrokerList = true

      if (this.totalValue == 100) {
        this.showsharedformData = true
      } else {
        this.showsharedformData = false
      }

      // this.brokerregform.get('brokerCount').setValue(this.brokersalesCodes.length);
    }
    this.labeldata = []
    this.realdata = []
    console.log(this.brokersalesCodes)
    for (let i = 0; i < this.brokersalesCodes.length; i++) {
      this.labeldata.push(this.brokersalesCodes[i].brokerName);
      this.realdata.push(this.brokersalesCodes[i].commission);
      // this.colordata.push(this.chartInfo[i].colorcode);
    }

    this.createChart(this.labeldata, this.realdata);
    // }

    this.allBrokersUnique.map((data) => {
      console.log(data)
      console.log(this.brokersalesCodes)

      this.brokersalesCodes.forEach((product) => {

        if (data.id == product.brokerId) {
          this.showSelectdAdvsiors.push(data)

        }


      })

      console.log("showmulti", this.showSelectdAdvsiors)

    });

    this.broker['ParentbrokerName'].setValue(this.showSelectdAdvsiors);
  }

  getPlansId() {
    this.plansIds = [];
    Object.keys(this.allplansArray).forEach((product: any) => {
      return Object.keys(this.allplansArray[product]).forEach((plan: any) => {
        if (
          typeof this.allplansArray[product][plan] === 'object' &&
          this.allplansArray[product][plan].planCheckbox === true &&
          this.allplansArray[product][plan].planId
        ) {
          this.plansIds.push(this.allplansArray[product][plan].planId);
        }
      });
    });
    this.plansIds = this.plansIds.filter((item) => item !== null);
    console.log('planIds', this.plansIds);
  }

  // public logos = []

  cancelSignup() {
    this.showaddform = false;
    this.saveError = false;
    this.showFormsDetails = false;
    this.addformDetails = [];
    this.allplansArray = [];
    this.showPlans = false;
    this.formCreation.reset();
    this.brokerregform.patchValue({
      signupForm: 'false',
    });
    // console.log(this.brokerregform.controls)
    this.closePlans();
  }

  addform() {
    this.getPlansId();
    this.plansIds.length <= 0
      ? (this.plansError = true)
      : (this.plansError = false);
    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      return;
    }
    this.saveError = false;

    let logoDetails = '';
    if (this.uploadFormlogo) {
      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }

    let image;

    console.log(this.uploadFormlogo, 'uploadformlogo');

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {
        image = reader.result;
      };
    }
    // else {

    //   image = this.allBrokers.filter(broker => broker.id == this.brokerregform.value.ParentbrokerName);
    // }
    // console.log(

    // )
    // this.logos.push(image)
    // console.log(this.logos, "logos")

    setTimeout(() => {
      let obj = {
        formType: 'CUSTOM',
        name: this.capitalize(this.formCreation.value.formName),
        profile: this.formCreation.value.profileName,
        description: this.capitalize(this.formCreation.value.formDescription),
        link: '',
        planLevels: this.plansIds,
        productType: this.formCreation.value.pricingOptions || 'GIG',
        logo: logoDetails || '',
        // logodisplay: image
        // formDisclosureAgreement: this.licenseform.value.formdisclosureAgreement || "",
      };

      // console.log({ obj })

      this.addformDetails.push(obj);
      console.log(this.addformDetails);
      // // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
      // const preservedValues = {
      //   parentlogo: this.formCreation.get('parentlogo')?.value,

      //   parentdisclosure: this.formCreation.get('parentdisclosure')?.value,
      //   signupForm: this.formCreation.get('signupForm')?.value

      // };



      this.formCreation.reset();
      this.showFormsDetails = true;
      this.showaddform = false;
      this.showPlans = false;
      this.showPricing = false;

      this.fromplansarry = [];
      this.plansIds = [];
      this.customForm = false;
      $('#addFormDetails').modal('hide');
      this.showaddplanss = false;
      $('#sumamryModel').modal('show');

      sessionStorage.setItem(
        'addformDetails',
        JSON.stringify(this.addformDetails)
      );

      this.uploadFormlogo = '';
    }, 100);
  }
  addform1() {
    // this.getPlansId();
    
    this.plansIds =  JSON.parse(sessionStorage.getItem('plansIds') ?? '[]')
    console.log('this.plansIds',this.plansIds);

    this.plansIds.length <= 0
      ? (this.plansError = true)
      : (this.plansError = false);
    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      return;
    }
    this.saveError = false;

    let logoDetails = '';
    if (this.uploadFormlogo) {
      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }

    let image;

    console.log(this.uploadFormlogo, 'uploadformlogo');

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {
        image = reader.result;
      };
    }
    // else {

    //   image = this.allBrokers.filter(broker => broker.id == this.brokerregform.value.ParentbrokerName);
    // }
    // console.log(

    // )
    // this.logos.push(image)
    // console.log(this.logos, "logos")

    setTimeout(() => {
      let obj = {
        formType: 'CUSTOM',
        name: this.capitalize(this.formCreation.value.formName),
        profile: this.formCreation.value.profileName,
        description: this.capitalize(this.formCreation.value.formDescription),
        link: '',
        planLevels: this.plansIds,
        productType: this.formCreation.value.pricingOptions || 'GIG',
        // logo: {logoDetails} || '',
        logo: {},
        // logodisplay: image
        // formDisclosureAgreement: this.licenseform.value.formdisclosureAgreement || "",
      };

      // console.log({ obj })

      this.addformDetails.push(obj);
      console.log(this.addformDetails);
      // // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
      // const preservedValues = {
      //   parentlogo: this.formCreation.get('parentlogo')?.value,

      //   parentdisclosure: this.formCreation.get('parentdisclosure')?.value,
      //   signupForm: this.formCreation.get('signupForm')?.value

      // };



      this.formCreation.reset();
      this.showFormsDetails = true;
      this.showaddform = false;
      this.showPlans = false;
      this.showPricing = false;

      this.fromplansarry = [];
      this.plansIds = [];
      this.customForm = false;



      sessionStorage.setItem(
        'addformDetails',
        JSON.stringify(this.addformDetails)
      );

      this.uploadFormlogo = '';

      var formdata = new FormData();

      // formdata.append('disclosureAgreement', disclousreDetails);
      formdata.append('formDetails', JSON.stringify(this.addformDetails) || '');
      formdata.append('broker_name', '');
      formdata.append('sales_tracking_code', '');
      formdata.append('logo', logoDetails);

      console.log(formdata)


      var accessToken = sessionStorage.getItem('accessToken');

      var brokerRegistartion =
        '/api/ap/v2/broker/' + this.profileBasedOriginalId + '/createFormWithLogo';

      var requestOptions: any = {
        method: 'POST',

        body: formdata,

        redirect: 'follow',
        headers: {
          Authorization: 'Bearer ' + accessToken
        },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + brokerRegistartion, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // if (response.status== 200) {
          console.log("Tetshere")
          this.closePlans();
          this.addformDetails = []
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          this.getBrokerDetails()
          $('#addFormDetails').modal('hide');
          this.showaddplanss = false;
          $('#sumamryModel').modal('show');
          this.showsignupformoptions = false
          // }
        })
    }, 100);


  }

  getBrokerDetails() {

    console.log(this.route.snapshot.params['id'])
    // let broker= broker.id
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokersDetails = '/api/ap/broker/' + this.showsoleAdvisorDataResult.id + '/details';

    this.http
      .get(environment.apiUrl + GetBrokersDetails, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          console.log(response)
          if (response['status'] == 200 || response['statusCode'] == 200) {
            console.log(response)
            this.getBrokerProfiles(response.data.id)
            this.brokerFormData = response.data.forms ?? [];

            console.log(this.brokerFormData)
            if (this.brokerFormData.length == 0) {
              this.showsignupformoptions = true
            }
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
          // this.cdr.markForCheck();

        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  deletebrokerlicense(index: any) {
    const Data = this.addlicenseformData;
    const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

    sessionStorage.setItem(
      'addlicenseformData',
      JSON.stringify(this.addlicenseformData)
    );
    this.addlicenseformData = JSON.parse(
      sessionStorage.getItem('addlicenseformData') || '[]'
    );

    if (this.addlicenseformData.length == 0) {
      this.addlicenseform = true;
      this.addlicenseformtable = false;
    }
  }
  deleteform(form: any, index: any) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete Form ' + form.name + '',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const Data = this.addformDetails;
        const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

        sessionStorage.setItem(
          'addformDetails',
          JSON.stringify(this.addformDetails)
        );
        this.addformDetails = JSON.parse(
          sessionStorage.getItem('addformDetails') || '[]'
        );

        if (this.addformDetails.length == 0) {
          this.showaddform = true;
          this.showPlans = true;
          this.showFormsDetails = false;

        }
      }
    });
  }

  addlicense() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform.value);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));
    // alert(this.insurancestatename)
    let obj = {
      // provinces_id: this.insurancestate_id,
      // provinces_name: this.insurancestatename,
      // state_fusebill_id: this.fusebillId,
      // expiry_date:
      //   this.datePipe.transform(
      //     this.licenseform.value.expiryDate,
      //     'MMM-dd-yyyy'
      //   ) || '',
      // reminder_email: parseInt(this.licenseform.value.remainder_days),
      // license_num: this.licenseform.value.licenseNumber,
      // license_coverage: this.licenseform.value.licenseCoverage1,
      // provinceshortName: this.licenseform.value.state

      provinceId: this.insurancestate_id,
      provinceName: this.insurancestatename,
      provinceStaxbillId: this.fusebillId,
      expiryDate:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
      reminderMailDays: parseInt(this.licenseform.value.reminderMailDays),
      licenseNo: this.licenseform.value.licenseNo,
      licenseCoverage: this.licenseform.value.licenseCoverage,
      provinceshortName: this.licenseform.value.state  //
    };
    let licenceExist = false;

    for (let broker of this.addlicenseformData) {
      if (broker.licenseNo == obj.licenseNo) {
        licenceExist = true;
        break;
      } else {
        licenceExist = false;
      }
    }
    if (licenceExist) {
      Swal.fire({ title: 'Info', text: 'License Number already exist' });
    } else {
      this.addlicenseformData.push(obj);
      console.log(this.addlicenseformData);
      this.insurancestate_id = '';
      this.insurancestatename = '';
      this.fusebillId = '';
      // // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
      this.licenseform.reset();
      this.addlicenseformtable = true;
      this.addlicenseform = false;
      sessionStorage.setItem(
        'addlicenseformData',
        JSON.stringify(this.addlicenseformData)
      );
      $('#basicModal1').modal('hide');
    }
  }

  addlicenseShared() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform.value);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));
    // alert(this.insurancestatename)
    let obj = {
      // provinces_id: this.insurancestate_id,
      // provinces_name: this.insurancestatename,
      // state_fusebill_id: this.fusebillId,
      // expiry_date:
      //   this.datePipe.transform(
      //     this.licenseform.value.expiryDate,
      //     'MMM-dd-yyyy'
      //   ) || '',
      // reminder_email: parseInt(this.licenseform.value.remainder_days),
      // license_num: this.licenseform.value.licenseNumber,
      // license_coverage: this.licenseform.value.licenseCoverage1,
      // provinceshortName: this.licenseform.value.state

      provinceId: this.insurancestate_id,
      provinceName: this.insurancestatename,
      provinceStaxbillId: this.fusebillId,
      expiryDate:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
      reminderMailDays: parseInt(this.licenseform.value.reminderMailDays),
      licenseNo: this.licenseform.value.licenseNo,
      licenseCoverage: this.licenseform.value.licenseCoverage,
      provinceshortName: this.licenseform.value.state  //
    };
    let licenceExist = false;

    for (let broker of this.addlicenseformData) {
      if (broker.licenseNo == obj.licenseNo) {
        licenceExist = true;
        break;
      } else {
        licenceExist = false;
      }
    }
    if (licenceExist) {
      Swal.fire({ title: 'Info', text: 'License Number already exist' });
    } else {
      this.addlicenseformData.push(obj);
      console.log(this.addlicenseformData);
      this.insurancestate_id = '';
      this.insurancestatename = '';
      this.fusebillId = '';
      // // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
      this.licenseform.reset();
      this.addlicenseformtable = true;
      this.addlicenseform = false;
      sessionStorage.setItem(
        'addlicenseformData',
        JSON.stringify(this.addlicenseformData)
      );
      $('#basicModal1Shared').modal('hide');
      $('#BrokerSharedNewDetails').modal('show');

    }
  }
  editbrokerlicense(broker: any, index: any) {
    console.log(broker);
    this.editindex = index;
    this.editbrokerlicensenumber = broker.license_num;
    this.editbrokerlicensecoverage = broker.license_coverage;
    this.editbrokerlicensestate = broker.provinces_name;
    this.editbrokerlicenseexpirydate = broker.expiry_date;
    this.editbrokerlicenseexpiryremainder = broker.reminder_email;
    this.editbrokerlicenseshortName = broker.provinceshortName;

    console.log(this.editbrokerlicenseexpirydate);
  }

  editform(form: any, index: any) {
    this.editindex = index;
    this.editFormType = 'CUSTOM';
    this.editFormName = form.name;
    this.editFormProfile = form.profile
    this.editFormDescription = form.description;
    this.editFormlink = '';
    this.editFormlogo = '';
    this.editFormDisclousreAggrement = '';
  }

  editbrokerlicenseSubmit() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));
    // this.getprovinceshortName(this.licenseform.value.state);
    this.insuranceprovincelist1(this.licenseform.value.state);


    let obj = {
      // provinces_id: this.insurancestate_id || this.brokerlicensedetails.provinces_id,
      // provinces_name: this.insurancestatename || this.brokerlicensedetails.provinces_name,
      // state_fusebill_id: this.fusebillId || this.brokerlicensedetails.state_fusebill_id,
      // expiry_date:
      //   this.datePipe.transform(
      //     this.licenseform.value.expiryDate,
      //     'MMM-dd-yyyy'
      //   ) || '',
      // reminder_email: parseInt(this.licenseform.value.remainder_days),
      // license_num: this.licenseform.value.licenseNumber,
      // license_coverage: this.licenseform.value.licenseCoverage1,
      // provinceshortName: this.shortNameValue

      provinceId:
        this.insurancestate_id || this.brokerlicensedetails.provinces_id,
      provinceName:
        this.insurancestatename || this.brokerlicensedetails.provinces_name,
      provinceStaxbillId:
        this.fusebillId || this.brokerlicensedetails.state_fusebill_id,
      expiryDate:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
      reminderMailDays: parseInt(this.licenseform.value.reminderMailDays),
      licenseNo: this.licenseform.value.licenseNo,
      licenseCoverage: this.licenseform.value.licenseCoverage,
      provinceshortName: this.licenseform.value.state

    };

    console.log({ obj });

    let licenceExist = false;
    for (let index in this.addlicenseformData) {
      if (
        this.addlicenseformData[index].license_num == obj.licenseNo &&
        index != this.editindex
      ) {
        licenceExist = true;
        break;
      } else {
        licenceExist = false;
      }
    }

    if (licenceExist) {
      Swal.fire({ title: 'Info', text: 'License Number already exist' });
    } else {
      this.addlicenseformData[this.editindex] = obj;

      sessionStorage.setItem(
        'addlicenseformData',
        JSON.stringify(this.addlicenseformData)
      );
      this.addlicenseformData = JSON.parse(
        sessionStorage.getItem('addlicenseformData') || '[]'
      );

      this.licenseform.reset();
      this.addlicenseform = false;
      this.addlicenseformtable = true;
      $('#basicModaledit').modal('hide');
    }

    // $('#basicModal1').modal('hide');
  }
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }
  editbrokerlicenseSharedSubmit() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));
    this.insuranceprovincelist1(this.licenseform.value.state);

    let obj = {
      // provinces_id: this.insurancestate_id || this.brokerlicensedetails.provinces_id,
      // provinces_name: this.insurancestatename || this.brokerlicensedetails.provinces_name,
      // state_fusebill_id: this.fusebillId || this.brokerlicensedetails.state_fusebill_id,
      // expiry_date:
      //   this.datePipe.transform(
      //     this.licenseform.value.expiryDate,
      //     'MMM-dd-yyyy'
      //   ) || '',
      // reminder_email: parseInt(this.licenseform.value.remainder_days),
      // license_num: this.licenseform.value.licenseNumber,
      // license_coverage: this.licenseform.value.licenseCoverage1,
      // provinceshortName: this.shortNameValue

      provinceId:
        this.insurancestate_id || this.brokerlicensedetails.provinces_id,
      provinceName:
        this.insurancestatename || this.brokerlicensedetails.provinces_name,
      provinceStaxbillId:
        this.fusebillId || this.brokerlicensedetails.state_fusebill_id,
      expiryDate:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
      reminderMailDays: parseInt(this.licenseform.value.reminderMailDays),
      licenseNo: this.licenseform.value.licenseNo,
      licenseCoverage: this.licenseform.value.licenseCoverage,
      provinceshortName: this.provinceshortName

    };

    console.log({ obj });

    let licenceExist = false;
    for (let index in this.addlicenseformData) {
      if (
        this.addlicenseformData[index].license_num == obj.licenseNo &&
        index != this.editindex
      ) {
        licenceExist = true;
        break;
      } else {
        licenceExist = false;
      }
    }

    if (licenceExist) {
      Swal.fire({ title: 'Info', text: 'License Number already exist' });
    } else {
      this.addlicenseformData[this.editindex] = obj;

      sessionStorage.setItem(
        'addlicenseformData',
        JSON.stringify(this.addlicenseformData)
      );
      this.addlicenseformData = JSON.parse(
        sessionStorage.getItem('addlicenseformData') || '[]'
      );

      this.licenseform.reset();
      this.addlicenseform = false;
      this.addlicenseformtable = true;
      $('#basicModaleditShared').modal('hide');
      $('#BrokerSharedNewDetails').modal('show');
    }

    // $('#basicModal1').modal('hide');
  }
  editFormSubmit12() {
    // console.log(this.uploadFormlogo, this.editFormdisplaylogo)

    this.getPlansId();
    this.plansIds.length <= 0
      ? (this.plansError = true)
      : (this.plansError = false);

    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      console.log(this.formCreation.value, this.plansIds.length);
      return;
    }
    console.log(JSON.stringify(this.formCreation.value, null, 2));

    let logoDetails = '';

    if (this.uploadFormlogo) {
      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }

    let image;

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {
        image = reader.result;
        this.editFormlogo = image;
      };
    }

    console.log(this.plansIds, 'plans');
    const capturedPlansIds = [...this.plansIds];

    setTimeout(() => {
      let obj = {
        formType: 'CUSTOM',
        name: this.capitalize(this.formCreation.value.formName),
        description: this.capitalize(this.formCreation.value.formDescription),
        link: '',
        planLevels: [...capturedPlansIds],
        logo: logoDetails || this.editFormlogo || '',
        productType: this.formCreation.value.pricingOptions || 'GIG',
        profile: this.formCreation.value.profileName
        // logodisplay: image || this.editFormdisplaylogo || ""
      };
      console.log(obj);
      console.log(this.editindex);
      this.addformDetails[this.editindex] = obj;
      this.uploadFormlogo = '';
      console.log(this.addformDetails, 'addformDetails');

      // this.formCreation.reset();
      this.showFormsDetails = true;
      this.insurancestate_id = '';
      this.insurancestatename = '';
      this.fusebillId = '';
      sessionStorage.setItem(
        'addformDetails',
        JSON.stringify(this.addformDetails)
      );
      $('#basicModalFormedit').modal('hide');
      $('#sumamryModel').modal('show');
    }, 100);

    this.plansIds = [];
  }

  hideaddlicenseform() {
    this.licenseform.reset();
  }
  hideaddlicenseformShared() {
    this.licenseform.reset();
    $('#basicModaleditShared').modal('hide');
    $('#basicModal1Shared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');
  }
  resetFormCreation() {
    this.plansError = false;
    this.formCreation.reset();
    // this.allplansArray = [];
    $('#basicModalFormedit').modal('hide');
    $('#addFormDetails').modal('hide');
    this.showaddplanss = false;
    $('#sumamryModel').modal('show');
    this.closePlans();
  }

  phoneFormat(id: any) {
    const inputValue = this.brokerregform.get(id).value;

    this.brokerregform
      .get(id)
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  phoneFormatShared(id: any) {
    const inputValue = this.brokerSharedregform.get(id).value;

    this.brokerSharedregform
      .get(id)
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  phoneFormatDynamic(id: any, form: any) {
    const inputValue = this.grpcontact[id].value;

    this.grpcontact[id].setValue(this.phoneNoFormat.transform(inputValue), {
      emitEvent: false,
    });
  }

  textChangeToLowerCase(id: any) {
    // let val = this.broker[id].value.toLowerCase();
    // this.broker[id].setValue(val);
    // this.brokerregform.get(id).updateValueAndValidity();
  }
  textChangeToLowerCase1(id: any) {
    // let val = this.brokerShared[id].value.toLowerCase();
    // this.broker[id].setValue(val);
    // this.brokerSharedregform.get(id).updateValueAndValidity();
  }

  phoneFormatForGroupCont(form: FormGroup, id: any) {
    const inputValue = form.get(id).value;
    //this.adminform.controls
    form
      .get(id)
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }

  // public logoDisplayInList: any;

  showLogoDisplayList(item: any) {
    if (item.logo) {
      var reader = new FileReader();
      reader.readAsDataURL(item.logo);

      reader.onload = (_event) => {
        this.logoDisplayInList = reader.result;
      };
    } else {
      this.logoDisplayInList = this.displaylogo || '';
    }

    // console.log(item, this.logoDisplayInList);
    return this.logoDisplayInList;
  }

  addextraform() {
    this.showparentformlogocondition = false;
    this.showParentLogoDisplay = false;
    this.customForm = false;
    this.allplansArray = [];
    this.initializePlansArray(this.productsArray, false, false, 'CUSTOM');
    this.showPlans = true;
    this.formCreation.get('Signupformtype').setValue('');
    this.formCreation.get('Signupformtype').updateValueAndValidity();
    // this.form['formplanLevels'].clearValidators();

    // this.form['formplanLevels'].updateValueAndValidity();
    // const preservedValues = {
    //   parentlogo: this.formCreation.get('parentlogo')?.value,

    //   parentdisclosure: this.formCreation.get('parentdisclosure')?.value,
    //   signupForm: this.formCreation.get('signupForm')?.value

    // };
    this.showaddplans = true;
    this.showeditplans = false;

    this.formCreation.reset();
    $('#sumamryModel').modal('hide');
    $('#addFormDetails').modal('show');
    this.showaddplanss = true;

    // this.showaddform = true;
  }

  uploadadminlogo(event1: any) {
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();
    console.log({ fileExtension });
    this.uploadlogo = event1.target.files[0];


    var allowedMimes = ['image/jpeg', 'image/pjpeg', 'image/png'];

    let error = false;
    let message = '';

    if (allowedMimes.includes(this.uploadlogo.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);
      if (this.uploadlogo.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;

          this.imagedisplay = reader.result;
          this.displaylogo = reader.result;
        };

        let logo = ''
        if (this.uploadlogo) {
          (logo = this.uploadlogo),
            'Admin_logo' +
            Date.now() +
            '.' +
            this.uploadlogo.name.split('.').pop().toLowerCase();
        } else {
          logo = '';
        }
        var formdata = new FormData();

        formdata.append('id', this.showsoleAdvisorDataResult.id);
        formdata.append('name', this.showsoleAdvisorDataResult.name);
        formdata.append('logo', logo);
        formdata.append('useParentsLogo', 'false');
        formdata.append('uploadLogo', 'true');
        formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
        formdata.append('disclosureAgreement', '');
        formdata.append('useParentsDisclosure', 'false');
        formdata.append('uploadTermsAndConditions', 'false');
        formdata.append('useParentsTerms', 'false');
        formdata.append('termsAndConditions', 'false');




        var endPoint = '/api/ap/broker/uploadResources';
        var accessToken = sessionStorage.getItem('accessToken');

        var requestOptions: any = {
          method: 'POST',

          body: formdata,

          redirect: 'follow',
          headers: { Authorization: 'Bearer ' + accessToken },
        };

        // console.log(requestOptions)

        fetch(environment.apiUrl + endPoint, requestOptions)
          .then((response) => response.text())

          .then((response: any) => {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
          })


      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // alert(message);
      }
    } else {
      error = true;
      message = 'Invalid file type. Only jpg,jpeg,png image files are allowed.';
      // alert(message);
    }
    if (error) {
      Swal.fire({
        title: 'Error',
        text: message,
      }).then((res) => {
        if (res.isConfirmed) {
          this.broker['logo'].setValue(null);
        }
      });
    }
  }
  // public showadminformlogo: boolean = true
  uploadadminFormlogo(event1: any) {
    console.log('test');

    console.log(event1.target);
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();
    console.log({ fileExtension });
    this.uploadFormlogo = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      // 'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadFormlogo.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadFormlogo.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          // this.showadminformlogo = false;
          this.editFormlogo = reader.result;

          const formLogoControl = this.formCreation.get('formlogo');
          formLogoControl.clearValidators();
          formLogoControl.updateValueAndValidity();
          // this.imagedisplay = reader.result;
        };
      } else {
        error = true;
        // message = 'File size is too large,maximum file size is 5 MB'

        message = `File size is too large,maximum file size is 5 MB`

        // alert(message);
      }
    } else {
      error = true;
      message = 'Invalid file type. Only jpg,jpeg,png image files are allowed.';
      // alert(message);
    }
    if (error) {
      Swal.fire({
        title: 'Error',
        text: message,
      }).then((res) => {
        if (res.isConfirmed) {
          this.form['formlogo'].setValue(null);
        }
      });
    }
  }
  public disclosureAgg = '';
  public imageDisclosure = '';

  public openPdf() {
    $('#disclosure').modal('show');
  }

  uploadadmindisclosure(event1: any) {
    console.log('test');
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    console.log(event1.target.files[0].name);
    this.uploaddisclousreAggrement = event1.target.files[0];
    this.disclosureAgg = event1.target.files[0].name;
    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    const extensionImageMap = {
      '.pdf': '../../../assets/img/pdf.png',
      '.png': '../../../assets/img/png.png',
      '.jpg': '../../../assets/img/jpg.png',
    };

    this.imageDisclosure = extensionImageMap[fileExtension.toLowerCase()] || '';
    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploaddisclousreAggrement.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);
      // alert(maxFileSize)

      if (this.uploaddisclousreAggrement.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showdisclosureaggrement = false;

          this.imagedisplaypdf = reader.result;
          // console.log(this.imagedisplaypdf)
        };

        let aggrement = ''
        if (this.uploaddisclousreAggrement) {
          (aggrement = this.uploaddisclousreAggrement),
            'Admin_logo' +
            Date.now() +
            '.' +
            this.uploaddisclousreAggrement.name.split('.').pop().toLowerCase();
        } else {
          aggrement = '';
        }

        var formdata = new FormData();

        formdata.append('id', this.showsoleAdvisorDataResult.id);
        formdata.append('name', this.showsoleAdvisorDataResult.name);
        formdata.append('logo', '');
        formdata.append('useParentsLogo', 'false');
        formdata.append('uploadDisclosureAgreement', 'true');
        formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
        formdata.append('disclosureAgreement', aggrement);
        formdata.append('uploadDisclosureAgreement', 'true');
        formdata.append('useParentsDisclosure', 'false');
        formdata.append('uploadTermsAndConditions', 'false');
        formdata.append('useParentsTerms', 'false');
        formdata.append('termsAndConditions', 'false');


        // formdata.append('id', '155');
        // formdata.append('name', 'Res1');
        // formdata.append('logo', '');
        // formdata.append('useParentsLogo', 'false');
        // formdata.append('parentId', '150');
        // formdata.append('disclosureAgreement', aggrement);
        // formdata.append('useParentsDisclosure', 'false');

        var endPoint = '/api/ap/broker/uploadResources';
        var accessToken = sessionStorage.getItem('accessToken');

        var requestOptions: any = {
          method: 'POST',

          body: formdata,

          redirect: 'follow',
          headers: { Authorization: 'Bearer ' + accessToken },
        };
        fetch(environment.apiUrl + endPoint, requestOptions)
          .then((response) => response.text())

          .then((response: any) => {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            if (response.status == 202) {
              Swal.fire({ title: 'Info', text: "No parent logo exists, please upload logo" });
            }
          })
      } else {
        error = true;

        message = `File size is too large,maximum file size is 5 MB`
        //  message = 'File size is too large,maximum file size is 5 MB'
        alert(message);
      }
    } else {
      error = true;

      message = 'Invalid file type. Only jpg, png image,pdf files are allowed.';
      alert(message);
    }
  }

  getimage(event) {
    console.log(event);
    var reader = new FileReader();
    reader.readAsDataURL(event);

    reader.onload = (_event) => {
      console.log(reader.result);
      // this.showimagelogo = false;

      // this.imagedisplay = reader.result;
    };
  }
  formConfig() {
    // var endPoint = '/api/ap/broker/formConfig';
    // var accessToken = sessionStorage.getItem('accessToken');

    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       if (response['status'] == 200) {
    //         // this.allBrokers = response.data.allBrokers;

    //         this.allBrokers = [...new Set(response.data.allBrokers)];
    //         this.allBrokers = response.data.allBrokers.sort((a: any, b: any) =>
    //           a.name > b.name ? 1 : -1
    //         );
    //         if (this.allBrokers.length > 0) {

    //         }
    //         else {
    //           this.broker['ParentbrokerName'].clearValidators();

    //           this.broker['ParentbrokerName'].updateValueAndValidity();
    //         }

    //         // this.allBrokersUnique = [...new Set(response.data.allBrokers)];
    //         this.allBrokersUnique = response.data.allBrokers.sort(
    //           (a: any, b: any) => (a.name > b.name ? 1 : -1)
    //         );
    //         this.prevSTC = response.data.prevSTC;
    //         let statesOfCanada = response.data.states.filter((country) => {
    //           if (country.countryId == 1) return country;
    //         });
    //         response.data.states = statesOfCanada;
    //         this.configprovinceres = response.data.states.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );
    //         this.licenseCoverageList = response.data.licenseCoverage;
    //         this.brokerType = response.data.brokerType;
    //         this.formType = response.data.formType;
    //         this.productsArray = response.data.packages;
    //         this.advisorGroupContact = response.data.advisorGroupContact;
    //         this.pricingOptions = response.data.forms;

    //         // for (let i = 0; i < this.productsArray.length; i++) {

    //         //   for (let j = 0; j < this.productsArray[i].planGroups.length; j++) {

    //         //     this.productsArrayList.push(this.productsArray[i].planGroups[j])
    //         //   }

    //         // }

    //         console.log(this.productsArrayList);
    //       } else {
    //         Swal.fire({ title: 'Error', text: response.message });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: 'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: false,
    //           confirmButtonText: 'Proceed',
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           } else {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         Swal.fire({ title: 'Error', text: error.error.error.message });
    //       }
    //     }
    //   );


    this.store.dispatch(loadBrokerFormConfigData());
    this.brokerFormConfigData$ = this.store.select(state => state.brokerFormConfigData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.brokerFormConfigData$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.brokerFormConfigData == undefined || Object.keys(data.brokerFormConfigData).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(Object.keys(this.brokerFormConfigData).length>0){
        return;
      }
      this.brokerFormConfigData = { ...data.brokerFormConfigData }

      this.allBrokers = [...new Set(this.brokerFormConfigData.allBrokers)];
      this.allBrokers = [...this.brokerFormConfigData.allBrokers].sort((a: any, b: any) =>
        a.name > b.name ? 1 : -1
      );
      if (this.allBrokers.length > 0) {}
      else {
        this.broker['ParentbrokerName'].clearValidators();
        this.broker['ParentbrokerName'].updateValueAndValidity();
      }
      this.allBrokersUnique = [...this.brokerFormConfigData.allBrokers].sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );
      this.prevSTC = this.brokerFormConfigData.prevSTC;
      let statesOfCanada = [...this.brokerFormConfigData.states].filter((country) => {
        if (country.countryId == 1) return country;
      });
      this.brokerFormConfigData.states = [...statesOfCanada];
      this.configprovinceres = [...this.brokerFormConfigData.states].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
      this.licenseCoverageList = this.brokerFormConfigData.licenseCoverage;
      this.brokerType = this.brokerFormConfigData.brokerType;
      this.formType = this.brokerFormConfigData.formType;
      this.productsArray = this.brokerFormConfigData.packages;
      this.advisorGroupContact = this.brokerFormConfigData.advisorGroupContact;
      this.pricingOptions = this.brokerFormConfigData.forms;

      } else {
        console.error('Observable returned undefined');
      }
    })

    // this.store.dispatch(loadBrokerConfigData({id: this.route.snapshot.params['id']}));
    // this.brokerConfigData$ = this.store.select(state => state.brokerConfigData).pipe(
    //   startWith([]),
    //   takeUntil(this.destroy$)
    // );

    // this.brokerConfigData$.subscribe(data => {
    //   if(data){
    //     console.log(data)
    //     if (data?.brokerConfigData == undefined || Object.keys(data.brokerConfigData).length <= 0) {
    //       console.log('No data to process', new Date().toISOString());
    //       return;
    //     }
    //     if(Object.keys(this.brokerConfigData).length>0){
    //       return;
    //     }
    //     this.brokerConfigData = data.brokerConfigData;

    //     this.allBrokers = [...new Set(this.brokerConfigData.allBrokers)];
    //     this.allBrokers = [...this.brokerConfigData.allBrokers].sort((a: any, b: any) =>
    //       a.name > b.name ? 1 : -1
    //     );
    //     if (this.allBrokers.length > 0) {}
    //     else {
    //       this.broker['ParentbrokerName'].clearValidators();
    //       this.broker['ParentbrokerName'].updateValueAndValidity();
    //     }
    //     this.allBrokersUnique = [...this.brokerConfigData.allBrokers].sort(
    //       (a: any, b: any) => (a.name > b.name ? 1 : -1)
    //     );
    //     this.prevSTC = this.brokerConfigData.prevSTC;
    //     let statesOfCanada = [...this.brokerConfigData.states].filter((country) => {
    //       if (country.countryId == 1) return country;
    //     });
    //     this.brokerConfigData.states = statesOfCanada;
    //     this.configprovinceres = [...this.brokerConfigData.states].sort(
    //       (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //     );
    //     this.licenseCoverageList = this.brokerConfigData.licenseCoverage;
    //     this.brokerType = this.brokerConfigData.brokerType;
    //     this.formType = this.brokerConfigData.formType;
    //     this.productsArray = this.brokerConfigData.packages;
    //     this.advisorGroupContact = this.brokerConfigData.advisorGroupContact;
    //     this.pricingOptions = this.brokerConfigData.forms;
    //   }
    // })
  }

  getbrokername() {
    let obj = {
      id: 0,
      brokerType: this.brokerregform.value.brokerType,
      name: this.brokerregform.value.brokersName,
      salesTrackingCode: 'New',
    };

    this.allBrokers.filter((object) => {
      if (object.id !== 0) {
        this.allBrokers.push(obj);
      }
    });
    // for(let i=0;i<this.allBrokers.length;i++){
    //   if(this.allBrokers[i].id !=0){
    //     this.allBrokers.push(obj)
    //   }
    //  }
  }

  onItemSelect() { }
  onItemDeSelect() { }
  public provincelist(event: any) {
    // alert(event.target.value)
    // if (event.target.value == 'QC') {
    //   $('#QCproviance').show();

    //   return false;
    // }
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.id);
        this.statename = element.name;
      }
    });

    if (this.brokerregform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.brokerregform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;

        this.broker['postalCode'].markAsTouched();
        this.broker['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
        // console.log("test1")
      }

      if (this.brokerregform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        // console.log("test11")
      }
    }
  }

  firstLetterNotSpace(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (event.currentTarget.value.length == 0) {
      //for first latter not allow space
      if (charCode === 32) {
        return false;
      } else {
        return true;
      }
    }
  }
  public insuranceprovincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.insurancestate_id = parseInt(element.id);
        this.insurancestatename = element.name;
        this.fusebillId = parseInt(element.fusebillId);
        this.provinceshortName = element.shortName
      }
    });
  }
  public insuranceprovincelist1(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.insurancestate_id = parseInt(element.id);
        this.insurancestatename = element.name;
        this.fusebillId = parseInt(element.fusebillId);
        this.provinceshortName = element.shortName
      }
    });
  }
  public getprovinceshortName(event: any) {
    this.configprovinceres.forEach((element: any) => {
      // console.log(element.shortName)
      // console.log(event)
      if (element.shortName == event) {
        this.shortNameValue = element.shortName;
      }
    });
  }
  changeTextToUppercase(field: any, event: any) {
    console.log(field);
    const obj = {};

    this.postalvalue = event.target.value;

    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      // console.log("r")
      this.invalidpostalcodeprivince = true;
      this.broker['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }

    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }

    console.log(this.invalidpostalcodeprivince);

    //  postalcodeValidator1(this.invalidpostalcodeprivince )
  }

  public signupFormCheck(event) {
    if (event.target.value == 'true') {
      this.showaddplans = true;
      this.showeditplans = false;
      this.showaddform = true;
      this.showsubmitform = true;
      this.showPlans = true;
      this.allplansArray = [];
      // this.formCreation.reset();
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM');
      // $('#addFormDetails').modal('show');
    } else {
      this.closePlans();
      this.showsubmitform = false;
      // this.showformtype = false;
      this.showaddform = false;
      this.saveError = false;
      this.showFormsDetails = false;
      this.addformDetails = [];
      this.allplansArray = [];
      this.showPlans = false;
      this.formCreation.reset();
      this.showParentLogoDisplay = false;

      // $('#addFormDetails').modal('hide');
    }
  }
  public checkParentlogo(event) {
    if (event.target.value == 'true') {
      // this.showParentLogoDisplay = true;
      this.showparentlogocondition = false;

      if (this.selectedBroker) {
        this.displaylogo = this.selectedBroker[0].logo;
      }
      // console.log({ dis: this.showParentLogoDisplay })
      this.broker['logo'].clearValidators();

      this.broker['logo'].updateValueAndValidity();

      this.uploadlogo = '';
      this.imagedisplay = '';
      this.showimagelogo = true;


      var formdata = new FormData();

      formdata.append('id', this.showsoleAdvisorDataResult.id);
      formdata.append('name', this.showsoleAdvisorDataResult.name);
      formdata.append('logo', '');
      formdata.append('useParentsLogo', 'true');
      formdata.append('uploadLogo', 'false');
      formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
      formdata.append('disclosureAgreement', '');
      formdata.append('useParentsDisclosure', 'false');
      formdata.append('uploadTermsAndConditions', 'false');
      formdata.append('useParentsTerms', 'false');
      formdata.append('termsAndConditions', 'false');




      var endPoint = '/api/ap/broker/uploadResources';
      var accessToken = sessionStorage.getItem('accessToken');

      var requestOptions: any = {
        method: 'POST',

        body: formdata,

        redirect: 'follow',
        headers: { Authorization: 'Bearer ' + accessToken },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + endPoint, requestOptions)
        .then((response) => response.text())

        .then((response: any) => {
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          if (response.status == 202) {
            Swal.fire({ title: 'Info', text: "No parent logo exists, please upload logo" });
          }
        })
    } else {
      this.showparentlogocondition = true;
      this.broker['logo'].setValidators([Validators.required]);

      this.broker['logo'].updateValueAndValidity();
      this.imagedisplay = '';
    }
  }
  public parentLogo = '';
  public showParentLogoDisplay = false;

  public checkParentFormlogo(event) {
    if (event.target.value == 'true') {
      this.showparentformlogocondition = false;
      if (this.selectedBroker && this.selectedBroker[0]?.logo) {
        this.showParentLogoDisplay = true;
      }
      const formLogoControl = this.formCreation.get('formlogo');
      formLogoControl.clearValidators();
      formLogoControl.updateValueAndValidity();

      console.log(this.formCreation.controls);

      this.uploadFormlogo = '';
      this.editFormdisplaylogo = '';
      this.editFormlogo = '';
      console.log(
        this.brokerregform.value.parentlogo,
        this.brokerregform.value.logo,
        this.brokerregform.value
      );
      console.log(this.addformDetails.length);
      // if (this.brokerregform.value.logo) {
      //   console.log("no parentlogo")
      //   this.logosArray[this.addformDetails.length] = this.imagedisplay

      // } else {
      //   if (this.selectedBroker) {
      //     console.log("yes parentlogo", this.selectedBroker, this.selectedBroker?.logo)

      //     this.logosArray[this.addformDetails.length] = this.selectedBroker[0]?.logo
      //   }
      // }
      // console.log({ logos: this.logosArray })
      // this.imagedisplay =""
      // this.showimagelogo =true
    }
    if (event.target.value == 'false') {
      this.showparentformlogocondition = true;
      this.showParentLogoDisplay = false;

      const formLogoControl = this.formCreation.get('formlogo');
      if (this.editFormlogo || this.uploadFormlogo) {
        formLogoControl.clearValidators();
        formLogoControl.updateValueAndValidity();
      } else {
        formLogoControl.setValidators(Validators.required);
        formLogoControl.updateValueAndValidity();
      }

      console.log(this.formCreation.controls);
      // this.imagedisplay =""
    }
  }
  public checkParentdisclosure(event) {
    if (event.target.value == 'true') {
      this.showparentdisclosurecondition = false;
      this.uploaddisclousreAggrement = '';
      this.disclosureAgg = '';
      this.imageDisclosure = '';
      this.imagedisplaypdf = '';
      this.showdisclosureaggrement = true;
      this.broker['disclosureAgreement'].clearValidators();

      this.broker['disclosureAgreement'].updateValueAndValidity();
      this.uploaddisclousreAggrement = '';
      var formdata = new FormData();

      formdata.append('id', this.showsoleAdvisorDataResult.id);
      formdata.append('name', this.showsoleAdvisorDataResult.name);
      formdata.append('logo', '');
      formdata.append('useParentsLogo', 'false');
      formdata.append('uploadDisclosureAgreement', 'false');
      formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
      formdata.append('disclosureAgreement', '');
      formdata.append('useParentsDisclosure', 'true');
      formdata.append('uploadTermsAndConditions', 'false');
      formdata.append('useParentsTerms', 'false');
      formdata.append('termsAndConditions', 'false');


      var endPoint = '/api/ap/broker/uploadResources';
      var accessToken = sessionStorage.getItem('accessToken');

      var requestOptions: any = {
        method: 'POST',

        body: formdata,

        redirect: 'follow',
        headers: { Authorization: 'Bearer ' + accessToken },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + endPoint, requestOptions)
        .then((response) => response.text())

        .then((response: any) => {
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          if (response.status == 202) {
            Swal.fire({ title: 'Info', text: "No parent logo exists, please upload logo" });
          }
        })
    } else {
      this.showparentdisclosurecondition = true;
      this.broker['disclosureAgreement'].setValidators([Validators.required]);

      this.broker['disclosureAgreement'].updateValueAndValidity();
    }
  }
  public checkSalesTrackingCode(event) {
    if (event.target.value == 'true') {
      let obj = {
        name: this.brokerregform.value.brokersName + '(Self)',
        brokerType: this.brokerregform.value.brokerType,
        salesTrackingCode: 'New',
        salesTrackingCodeWithStatement: 0,
        id: 0,
      };

      let pushSelf = true;
      console.log('AllBroker', this.allBrokers);
      this.allBrokers.map((broker) => {
        if (broker.id == 0) pushSelf = false;
      });
      if (pushSelf) this.allBrokers.push(obj);

      this.showsalestrackinCodeAuto = true;
      if (this.role == 'ADMINISTRATOR') {
        this.broker['user_generated_stc'].setValidators([Validators.required]);
        this.broker['user_generated_stc'].updateValueAndValidity();
        this.broker['user_generated_stc'].reset();
      }

      // if(this.brokerregform.value.brokersName && this.brokerregform.value.brokerType){

      //   let obj = {
      //     "id": 0,
      //     "brokerType": this.brokerregform.value.brokerType,
      //     "name": this.brokerregform.value.brokersName,
      //     "salesTrackingCode": "New"
      // }

      // this.allBrokers.filter(
      //   (object) => {
      //     if(object.id !== 0){
      //       this.allBrokers.push(obj)
      //     }
      //   }
      // );

      // }
    } else {
      this.broker['user_generated_stc'].clearValidators();
      this.broker['user_generated_stc'].updateValueAndValidity();

      this.broker['sales_tracking_code'].clearValidators();
      this.broker['sales_tracking_code'].updateValueAndValidity();
      this.showsalestrackinCodeAuto = false;
      this.showsales_tracking_code = false;
      // this.brokerregform.value.user_generated_stc = false
    }
  }

  public checkSalesTrackingCodeAuto(event) {
    if (event.target.value == 'false') {
      this.showsales_tracking_code = false;
      this.broker['sales_tracking_code'].clearValidators();
      this.broker['sales_tracking_code'].updateValueAndValidity();
      this.broker['sales_tracking_code'].reset();
    } else {
      this.showsales_tracking_code = true;

      this.broker['sales_tracking_code'].setValidators([
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(12),
      ]);
      this.broker['sales_tracking_code'].updateValueAndValidity();
    }
  }

  signUpFormType: string = '';

  showPlansForSelection() {
    if (this.signUpFormType === 'REGULAR') {
      this.initializePlansArray(this.productsArray, true, true, 'REGULAR');
    }
    if (this.signUpFormType === 'EXECUTIVE') {
      this.initializePlansArray(this.productsArray, false, true, 'EXECUTIVE');
    }
    if (this.signUpFormType === 'CUSTOM') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM');
    }
  }
  public showPlans: boolean = false;

  public selectFormname(event: any) {
    console.log(event.target.value);
    this.signUpFormType = event.target.value;
    this.showPlans = true;
    this.showPlansForSelection();
    if (event.target.value == 'REGULAR' || event.target.value == 'EXECUTIVE') {
      // this.showaddform = true;
      this.customForm = false;
      // this.form['formplanLevels'].clearValidators();
      //
      //  this.form['formplanLevels'].updateValueAndValidity();
    } else {
      this.customForm = true;
      // this.form['formplanLevels'].setValidators([Validators.required]);;

      // this.form['formplanLevels'].updateValueAndValidity();
    }

    for (let i = 0; i < this.formType.length; i++) {
      if (this.formType[i].label == event.target.value) {
        this.formTitle = this.formType[i].title;
        this.formDescription = this.formType[i].description;
      }
    }
  }

  public getBrokerlistData(event: any) {
    console.log(event.target.value);

    this.selectedBroker = this.allBrokersUnique.filter(
      (broker) => broker.id == event.target.value
    );

    console.log('broker:-', this.selectedBroker);
    this.brokerList = {
      ...this.brokerList,
      // name: this.selectedBroker[0]?.name,
      subBrokers:[],
      salesTrackingCode:'',
      customersCount: { corporate:0 },
      childsCount : { count:0 },
      EOIStatus:'Valid',
      published:true
    }
    this.displaylogo = this.selectedBroker[0].logo;
    // alert(this.brokerregform.value.ParentbrokerName);
    // Object.keys(this.brokerregform.controls).forEach((val, key) => console.log(`${val}: ${this.brokerregform.controls[val].value}`))
    // console.log(this.brokerregform.controls)
  }

  public getBrokerSharedExisting(broker: any) {

    console.log(this.getsharedexisting)
    this.brokersalesCodes.push({
      brokerId: this.getsharedexisting.id,
      brokerName: this.getsharedexisting.name,
      commission: '',
    });
    this.showsalestrackinCodeAuto = true;

    console.log(this.brokersalesCodes)
    $("#BrokerSharedNewDetails").hide()


    if (this.brokersalesCodes.length == this.broker['brokerCount'].value) {
      this.showSharedBrokerList = false
    }
    else {
      this.showSharedBrokerList = true
    }
    // this.brokersalesCodes.push({
    //   brokerId: response.data.broker.id,
    //   brokerName:response.data.broker.name,
    //   percentage: '',
    // });


  }

  groupContactChange(event: any) {
    if (event.target.value == 'ADVISOR_OTHERS') {
      this.ShowOthers = true;
      this.adminform.get('roleName').setValidators(Validators.required);
    } else {
      this.ShowOthers = false;
      this.adminform.get('roleName').clearValidators();
    }
    this.adminform.get('roleName').updateValueAndValidity();
  }

  disableScrolling(): void {
    const container = this.elRef.nativeElement.querySelector('.form-container');
    if (container) {
      this.renderer.setStyle(container, 'overflow-y', 'hidden');
    }
  }

  enableScrolling(): void {
    const container = this.elRef.nativeElement.querySelector('.form-container');
    if (container) {
      this.renderer.setStyle(container, 'overflow-y', 'auto');
    }
  }

  public getBrokerlistSalesData(event: any) {
    // console.log(event.target.value);
  }

  public getBrokerSelflist() {
    // this.allBrokers =[]

    let obj = {
      name: this.brokerregform.value.brokersName + '(Self)',
      brokerType: this.brokerregform.value.brokerType,
      salesTrackingCode: 'New',
      salesTrackingCodeWithStatement: 0,
      id: 0,
    };

    let pushSelf = true;
    console.log('AllBroker', this.allBrokers);
    // this.allBrokers.map((broker,index) => {
    //   if (broker.id == 0)
    //     pushSelf = false;
    //   Object.assign(target, obj);
    // });
    const target = this.allBrokers.find((obj) => obj.id === 0);

    if (target) {
      Object.assign(target, obj);
      pushSelf = false;
    } else {
      this.allBrokers.unshift(obj);
    }

    // if (pushSelf)
    //   this.allBrokers.push(obj);

    // console.log(this.allBrokers)
  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  copy(text: string) {
    this._clipboardService.copy(text);
    this.toastrService.success('link copied');
  }
  copylink() {
    this.toastrService.success('link copied to Clipboard');
  }

  // scroll(tar) {
  //   console.log("calling")
  //   console.log(tar)
  //   const buttonToScrollTo = this.elementRef.nativeElement.querySelector('#scrollTarget');
  //   console.log({ buttonToScrollTo })

  //   buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
  // }

  public showsalesTrackingData() {
    // let saleTrackingCodearr= []
    // for (let i = 0; i < this.brokersalesCodes.length; i++) {

    //   let obj = {
    //     "brokerId": parseInt(this.brokersalesCodes[i].brokerId) || "",
    //     "percentage": parseInt(this.brokersalesCodes[i].percentage) || 0,

    //   }
    //   this.salestrackingCodeTableData.push(obj)
    // }

    // // this.salestrackingCodeTableData = saleTrackingCodearr
    // // console.log(saleTrackingCodearr)
    // this.brokersalesCodes=[]
    // this.brokersalesCodes.push({
    //   brokerId: '',
    //   percentage: '',
    // });
    // console.log("entering")
    // this.showfulldetails = true

    // $('#sumamryModel').modal('show');
    // return

    this.submitbasicInfo();
  }

  public submitbasicInfo() {


    //There is no advsior deafult parent is 1, if there auto seelct
    // Object.keys(this.brokerregform.controls).forEach((val, key) => console.log(`${val}: ${this.brokerregform.controls[val].value}`))

    console.log(this.brokerregform.value);

    // return;
    // console.log(this.brokersalesCodes)

    this.plansIds.length <= 0 && this.showaddform
      ? (this.saveError = true)
      : (this.saveError = false);
    console.log(this.plansIds.length <= 0, this.formCreation.invalid);

    if (this.brokerregform.invalid || this.adminData.length == 0 || sessionStorage.getItem('addlicenseformData').length == 0) {
      console.log(this.adminform.value);

      const invalid = [];
      const controls = this.brokerregform.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid);

      this.brokerregform.markAllAsTouched();
      this.adminform.markAllAsTouched();
      this.licenseform.markAllAsTouched();
      this.formCreation.markAllAsTouched();
      this.scrollToFirstInvalidControl1();
      if (this.saveError) {
        const buttonToScrollTo =
          this.elementRef.nativeElement.querySelector('#scrollTarget');
        console.log({ buttonToScrollTo });

        buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      this._LoaderService.ShowLoader();

      let license = {
        // provinces_id: this.insurancestate_id,
        // provinces_name: this.insurancestatename,
        // expiry_date:
        //   this.datePipe.transform(
        //     this.licenseform.value.expiryDate,
        //     'MMM-dd-yyyy'
        //   ) || '',
        // reminder_email: parseInt(this.licenseform.value.remainder),
        // license_num: this.licenseform.value.licenseNumber,
        // license_coverage: this.licenseform.value.licenseCoverage1,

        provinceId: this.insurancestate_id,
        provinceName: this.insurancestatename,
        expiryDate:
          this.datePipe.transform(
            this.licenseform.value.expiryDate,
            'MM-dd-yyyy'
          ) || '',
        reminderMailDays: parseInt(this.licenseform.value.remainder),
        licenseNo: this.licenseform.value.licenseNumber,
        licenseCoverage: this.licenseform.value.licenseCoverage,
      };
      this.licensesInfo.push(license);
      let data: any = {
        formType: this.brokerregform.value.Signupformtype,
        name: this.brokerregform.value.formName,
        description: this.brokerregform.value.formDescription,
        link: this.brokerregform.value.formLink,
        planLevels: '',
      };

      console.log(data);
      this.SignupFormData.push(data);

      let disclousreDetails = '';
      let parentlogo = '';
      if (this.uploaddisclousreAggrement) {
        (disclousreDetails = this.uploaddisclousreAggrement),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploaddisclousreAggrement.name.split('.').pop().toLowerCase();
      } else {
        disclousreDetails = '';
      }

      if (this.uploadlogo) {
        (parentlogo = this.uploadlogo),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploadlogo.name.split('.').pop().toLowerCase();
      } else {
        parentlogo = '';
      }

      let saleTrackingCode: any = [
        { brokerId: 1, commission: 50 },
        { brokerId: 2, commission: 50 },
      ];

      let saleTrackingCodearr = [];
      for (let i = 0; i < this.brokersalesCodes.length; i++) {
        let obj = {
          brokerId: parseInt(this.brokersalesCodes[i].brokerId) || '',
          commission: parseInt(this.brokersalesCodes[i].commission) || 0,
        };
        saleTrackingCodearr.push(obj);
      }

      console.log(saleTrackingCodearr);

      for (let i = 0; i < saleTrackingCodearr.length; i++) {
        // if (saleTrackingCodearr[i].brokerid == "" || saleTrackingCodearr[i].percentage == "") {
        //   saleTrackingCodearr = []
        // }
        if (saleTrackingCodearr[i].brokerid == '') {
          saleTrackingCodearr = [];
        }
      }

      // if(this.brokerregform.value.stc_generation =="true"){
      // console.log("1")

      // }
      // else{
      //   console.log("2")
      //   this.brokerregform.value.user_generated_stc = "false"
      // }
      let FormDetails: any = this.addformDetails;

      var formdata = new FormData();
      let licensesData = sessionStorage.getItem('addlicenseformData');
      let licenses: any;
      licenses = licensesData ? JSON.parse(licensesData) : ''

      for (let i = 0; i < FormDetails.length; i++) {
        formdata.append('formLogo' + [i + 1] + '', FormDetails[i].logo);
      }
      let secondaryEmail = this.brokerregform.value.secondaryEmail || '';
      let thirdEmail = this.brokerregform.value.thirdEmail || '';

      if (thirdEmail) {
        secondaryEmail = `${secondaryEmail ? `${secondaryEmail},` : ''
          }${thirdEmail}`;
      }
      let inputData = {
        brokerCommissionType: 'sole',
        name: this.capitalize(this.brokerregform.value.brokersName),
        parentId: +this.brokerregform.value.ParentbrokerName || 1,
        brokerType: this.brokerTypeName,
        businessNumber: this.brokerregform.value.businessnumber || '',
        email: this.brokerregform.value.primaryEmail || '',
        secondaryEmail: secondaryEmail,
        address: {
          apt: '',
          line1: this.capitalize(this.brokerregform.value.streetAddress),
          line2: this.capitalize(this.brokerregform.value.streetAddress2) || '',
          city: this.capitalize(this.brokerregform.value.city) || '',
          province: this.brokerregform.value.Province || '',
          country: this.capitalize(this.brokerregform.value.country),
          postalCode: this.brokerregform.value.postalCode || '',
          provinceId: this.state_id,
          countryId: 1,
          primaryEmail: this.brokerregform.value.primaryEmail || '',
          secondaryEmail: secondaryEmail,
          primaryPhone: this.brokerregform.value.primaryPhone || '',
          secondaryPhone: this.brokerregform.value.secondaryPhone || '',
        },
        groupContacts: this.adminData || [],
        licenses: licenses || [],
        brokerEO: this.EOinsurenceInfo || undefined,

        // 'parent_name': this.brokerregform.value.ParentbrokerName,

        // 'country_id': '1',

        // 'state_id': this.state_id,
        // 'province_id': this.state_id,
        // 'city': this.capitalize(this.brokerregform.value.city) || "",
        // 'EOinsurence':JSON.stringify(this.EOinsurenceInfo) || '',
        // 'province':this.brokerregform.value.Province || "",
        // 'state': this.brokerregform.value.Province || "",
        // 'licenses': licenses,
        // 'street_address_line1':this.capitalize(this.brokerregform.value.streetAddress),
        // 'country':this.capitalize(this.brokerregform.value.country),
        // 'street_address_line2':this.capitalize(this.brokerregform.value.streetAddress2) || "",
      };

      formdata.append('brokerCommissionType', 'sole');
      formdata.append('parent_name', this.brokerregform.value.ParentbrokerName);
      formdata.append('postal_code', this.brokerregform.value.postalCode || '');
      formdata.append(
        'sales_tracking_code',
        this.brokerregform.value.sales_tracking_code?.replaceAll('-', '') || ''
      );
      formdata.append(
        'secondary_phone',
        this.brokerregform.value.secondaryPhone || ''
      );
      formdata.append(
        'business_number',
        this.brokerregform.value.businessnumber || ''
      );
      formdata.append('country_id', '1');
      formdata.append('apt', '');
      formdata.append('state_id', this.state_id);
      formdata.append('province_id', this.state_id);
      formdata.append(
        'city',
        this.capitalize(this.brokerregform.value.city) || ''
      );
      formdata.append('logo', parentlogo);
      formdata.append(
        'name',
        this.capitalize(this.brokerregform.value.brokersName)
      );
      formdata.append(
        'EOinsurence',
        JSON.stringify(this.EOinsurenceInfo) || ''
      );
      formdata.append('useParentsLogo', this.brokerregform.value.parentlogo);
      formdata.append('parent_id', this.brokerregform.value.ParentbrokerName);
      formdata.append('province', this.brokerregform.value.Province || '');
      formdata.append('state', this.brokerregform.value.Province || '');

      formdata.append('secondary_email', secondaryEmail);

      // formdata.append("sales_tracking_code_shares", JSON.stringify(saleTrackingCodearr))  //JSON.stringify(saleTrackingCodearr)
      formdata.append('licenses', licenses);
      formdata.append('brokerType', this.brokerTypeName);
      formdata.append(
        'street_address_line1',
        this.capitalize(this.brokerregform.value.streetAddress) || ''
      );
      formdata.append(
        'country',
        this.capitalize(this.brokerregform.value.country) || ''
      );
      formdata.append(
        'street_address_line2',
        this.capitalize(this.brokerregform.value.streetAddress2) || ''
      );
      // formdata.append('createSignupForm', this.brokerregform.value.signupForm);
      formdata.append('createSignupForm', 'false');

      formdata.append(
        'phone_number',
        this.brokerregform.value.primaryPhone || ''
      );
      formdata.append('email', this.brokerregform.value.primaryEmail || '');
      formdata.append('disclosureAgreement', disclousreDetails);
      formdata.append('formDetails', JSON.stringify(this.addformDetails) || '');
      formdata.append('stc_generation', 'true');
      // formdata.append('stc_generation', this.brokerregform.value.stc_generation);  //advisor---true,reaming:false
      formdata.append('user_generated_stc', 'false');
      // formdata.append('user_generated_stc', this.brokerregform.value.user_generated_stc || "false");  //advisor---true,reaming:false
      formdata.append('groupContacts', JSON.stringify(this.adminData));
      // formdata.append("formDisclosureAgreement1", "");

      var accessToken = sessionStorage.getItem('accessToken');
      // var brokerRegistartion = '/api/ap/broker/registrationNew1';
      // var brokerRegistartion = '/api/ap/v2/broker/registration/withGroupContact';

      var brokerRegistartion = '/api/ap/v3/broker/registration';

      var requestOptions: any = {
        method: 'POST',

        body: JSON.stringify(inputData),

        redirect: 'follow',
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + brokerRegistartion, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // console.log(response);
          response = JSON.parse(response);

          if (response['status'] == 200) {
            // this.showsoleAdvisorData = false;
            this._LoaderService.HideLoader();
            // this.showsalestrackingtable = true;
            // this.showAdvisorAdvData = true;
            // this.salesTrackingInfo = response.data.broker;
            this.showsoleAdvisorDataResult = response.data.broker

            const preservedValues = {
              parentlogo: this.brokerregform.get('parentlogo')?.value,

              parentdisclosure: this.brokerregform.get('parentdisclosure')?.value,
              signupForm: this.brokerregform.get('signupForm')?.value

            };
            this.brokerregform.reset(preservedValues);
            this.formConfig1(this.showsoleAdvisorDataResult.id)
            this.getBrokerProfiles(response.data.broker.id);
            // this.broker['parentlogo'].setValidators([Validators.required]);
            // this.broker['parentdisclosure'].setValidators([
            //   Validators.required,
            // ]);
            // this.broker['signupForm'].setValidators([Validators.required]);

            // this.broker['parentlogo'].updateValueAndValidity();
            // this.broker['parentdisclosure'].updateValueAndValidity();
            // this.broker['signupForm'].updateValueAndValidity();
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + getClients
            // ]);



            this.showfulldetails = true

            setTimeout(() => {
              $('#sumamryModel').modal('show');
            }, 2000);


            // this.salesTrackingCodeShares =
            //   response.data.salesTrackingCodeShares;
            // this.finalSummaryDataForm = response.data.form;
            // this.finalSummaryBrookerDataName = response.data.broker.name;
            // this.finalSummaryBrookerDataid = response.data.broker.id;
            // this.finalSumamryBrokerType = response.data.broker.brokerType;
            // this.finalSumamryBrokersalesTrackingCode =
            //   response.data.broker.salesTrackingCode;

            // this.finalSummaryBrookerDataBrokerType = response.data.broker.name;

            // response.data.information.EOinsurence.EOIexpiryDate = moment(response.data.information.EOinsurence.EOIexpiryDate).format('MMM-DD-YYYY');

            // this.finalSummaryDataEOinsurance.push(
            //   response.data.information.EOinsurence
            // );
            // console.log({ final: this.finalSummaryDataEOinsurance });
            // // this.finalSummaryDataEOinsurance=response.data.information.EOinsurence;

            // this.finalSummaryDatalicense = response.data.information.licenses;
            // this.brokerCommissions =
            //   response.data.information.brokerCommissions;

            // this.brokerregform.reset();
            // this.licenseform.reset();
            // this.formCreation.reset();

            sessionStorage.setItem('addlicenseformData', '');
            sessionStorage.setItem('addformDetails', '');
            // this.http.post(environment.apiUrl + '/api/ap/v2/global/set-adminAdvisors',{wait:true}).subscribe((newResponse) => {
            //   this.store.dispatch(loadAdvisorDataSuccess({advisorData:[]}))
            //   this.store.dispatch(loadAdvisorData())
            // })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => { })
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
                headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
              }).subscribe((res) => {
              console.log({ res })
            })
          } else {
            this._LoaderService.HideLoader();

            Swal.fire({ title: 'Error', text: response.message });
          }
        });
    }
  }
  submitSharedExisting() {
    $("#BrokerSharedNewDetails").hide()

  }
  public submitSharedNew() {
    // Object.keys(this.brokerregform.controls).forEach((val, key) => console.log(`${val}: ${this.brokerregform.controls[val].value}`))

    console.log(this.brokerregform.value);

    // return;
    // console.log(this.brokersalesCodes)

    this.plansIds.length <= 0 && this.showaddform
      ? (this.saveError = true)
      : (this.saveError = false);
    console.log(this.plansIds.length <= 0, this.formCreation.invalid);

    if (this.brokerregform.invalid || this.adminData.length == 0 || sessionStorage.getItem('addlicenseformData').length == 0 || this.saveError) {
      console.log(this.brokerregform.value);

      const invalid = [];
      const controls = this.brokerregform.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid);

      this.brokerregform.markAllAsTouched();
      this.adminform.markAllAsTouched();
      this.licenseform.markAllAsTouched();
      this.formCreation.markAllAsTouched();
      this.scrollToFirstInvalidControl1();
      if (this.saveError) {
        const buttonToScrollTo =
          this.elementRef.nativeElement.querySelector('#scrollTarget');
        console.log({ buttonToScrollTo });

        buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      this._LoaderService.ShowLoader();

      let license = {
        // provinces_id: this.insurancestate_id,
        // provinces_name: this.insurancestatename,
        // expiry_date:
        //   this.datePipe.transform(
        //     this.licenseform.value.expiryDate,
        //     'MMM-dd-yyyy'
        //   ) || '',
        // reminder_email: parseInt(this.licenseform.value.remainder),
        // license_num: this.licenseform.value.licenseNumber,
        // license_coverage: this.licenseform.value.licenseCoverage1,

        provinceId: this.insurancestate_id,
        provinceName: this.insurancestatename,
        expiryDate:
          this.datePipe.transform(
            this.licenseform.value.expiryDate,
            'MM-dd-yyyy'
          ) || '',
        reminderMailDays: parseInt(this.licenseform.value.remainder),
        licenseNo: this.licenseform.value.licenseNumber,
        licenseCoverage: this.licenseform.value.licenseCoverage,
      };
      this.licensesInfo.push(license);
      let data: any = {
        formType: this.brokerregform.value.Signupformtype,
        name: this.brokerregform.value.formName,
        description: this.brokerregform.value.formDescription,
        link: this.brokerregform.value.formLink,
        planLevels: '',
      };

      console.log(data);
      this.SignupFormData.push(data);

      let disclousreDetails = '';
      let parentlogo = '';
      if (this.uploaddisclousreAggrement) {
        (disclousreDetails = this.uploaddisclousreAggrement),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploaddisclousreAggrement.name.split('.').pop().toLowerCase();
      } else {
        disclousreDetails = '';
      }

      if (this.uploadlogo) {
        (parentlogo = this.uploadlogo),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploadlogo.name.split('.').pop().toLowerCase();
      } else {
        parentlogo = '';
      }



      let FormDetails: any = this.addformDetails;

      var formdata = new FormData();
      let licenses = JSON.parse(sessionStorage.getItem('addlicenseformData'));
      if (licenses == null) licenses = '';
      for (let i = 0; i < FormDetails.length; i++) {
        formdata.append('formLogo' + [i + 1] + '', FormDetails[i].logo);
      }
      let secondaryEmail = this.brokerregform.value.secondaryEmail || '';
      let thirdEmail = this.brokerregform.value.thirdEmail || '';

      if (thirdEmail) {
        secondaryEmail = `${secondaryEmail ? `${secondaryEmail},` : ''
          }${thirdEmail}`;
      }
      let inputData = {
        brokerCommissionType: 'sole',
        name: this.capitalize(this.brokerregform.value.brokersName),
        parentId: +this.brokerregform.value.ParentbrokerName || 1,
        brokerType: this.brokerTypeName,
        businessNumber: this.brokerregform.value.businessnumber || '',
        email: this.brokerregform.value.primaryEmail || '',
        secondaryEmail: secondaryEmail,
        address: {
          apt: '',
          line1: this.capitalize(this.brokerregform.value.streetAddress),
          line2: this.capitalize(this.brokerregform.value.streetAddress2) || '',
          city: this.capitalize(this.brokerregform.value.city) || '',
          province: this.brokerregform.value.Province || '',
          country: this.capitalize(this.brokerregform.value.country),
          postalCode: this.brokerregform.value.postalCode || '',
          provinceId: this.state_id,
          countryId: 1,
          primaryEmail: this.brokerregform.value.primaryEmail || '',
          secondaryEmail: secondaryEmail,
          primaryPhone: this.brokerregform.value.primaryPhone || '',
          secondaryPhone: this.brokerregform.value.secondaryPhone || '',
        },
        groupContacts: this.adminData || [],
        licenses: licenses || [],
        brokerEO: this.EOinsurenceInfo || undefined,

        // 'parent_name': this.brokerregform.value.ParentbrokerName,

        // 'country_id': '1',

        // 'state_id': this.state_id,
        // 'province_id': this.state_id,
        // 'city': this.capitalize(this.brokerregform.value.city) || "",
        // 'EOinsurence':JSON.stringify(this.EOinsurenceInfo) || '',
        // 'province':this.brokerregform.value.Province || "",
        // 'state': this.brokerregform.value.Province || "",
        // 'licenses': licenses,
        // 'street_address_line1':this.capitalize(this.brokerregform.value.streetAddress),
        // 'country':this.capitalize(this.brokerregform.value.country),
        // 'street_address_line2':this.capitalize(this.brokerregform.value.streetAddress2) || "",
      };

      formdata.append('brokerCommissionType', 'sole');
      formdata.append('parent_name', this.brokerregform.value.ParentbrokerName);
      formdata.append('postal_code', this.brokerregform.value.postalCode || '');
      formdata.append(
        'sales_tracking_code',
        this.brokerregform.value.sales_tracking_code?.replaceAll('-', '') || ''
      );
      formdata.append(
        'secondary_phone',
        this.brokerregform.value.secondaryPhone || ''
      );
      formdata.append(
        'business_number',
        this.brokerregform.value.businessnumber || ''
      );
      formdata.append('country_id', '1');
      formdata.append('apt', '');
      formdata.append('state_id', this.state_id);
      formdata.append('province_id', this.state_id);
      formdata.append(
        'city',
        this.capitalize(this.brokerregform.value.city) || ''
      );
      formdata.append('logo', parentlogo);
      formdata.append(
        'name',
        this.capitalize(this.brokerregform.value.brokersName)
      );
      formdata.append(
        'EOinsurence',
        JSON.stringify(this.EOinsurenceInfo) || ''
      );
      formdata.append('useParentsLogo', this.brokerregform.value.parentlogo);
      formdata.append('parent_id', this.brokerregform.value.ParentbrokerName);
      formdata.append('province', this.brokerregform.value.Province || '');
      formdata.append('state', this.brokerregform.value.Province || '');

      formdata.append('secondary_email', secondaryEmail);

      // formdata.append("sales_tracking_code_shares", JSON.stringify(saleTrackingCodearr))  //JSON.stringify(saleTrackingCodearr)
      formdata.append('licenses', licenses);
      formdata.append('brokerType', this.brokerTypeName);
      formdata.append(
        'street_address_line1',
        this.capitalize(this.brokerregform.value.streetAddress) || ''
      );
      formdata.append(
        'country',
        this.capitalize(this.brokerregform.value.country) || ''
      );
      formdata.append(
        'street_address_line2',
        this.capitalize(this.brokerregform.value.streetAddress2) || ''
      );
      // formdata.append('createSignupForm', this.brokerregform.value.signupForm);
      formdata.append('createSignupForm', 'false');

      formdata.append(
        'phone_number',
        this.brokerregform.value.primaryPhone || ''
      );
      formdata.append('email', this.brokerregform.value.primaryEmail || '');
      formdata.append('disclosureAgreement', disclousreDetails);
      formdata.append('formDetails', JSON.stringify(this.addformDetails) || '');
      formdata.append('stc_generation', 'true');
      // formdata.append('stc_generation', this.brokerregform.value.stc_generation);  //advisor---true,reaming:false
      formdata.append('user_generated_stc', 'false');
      // formdata.append('user_generated_stc', this.brokerregform.value.user_generated_stc || "false");  //advisor---true,reaming:false
      formdata.append('groupContacts', JSON.stringify(this.adminData));
      // formdata.append("formDisclosureAgreement1", "");

      var accessToken = sessionStorage.getItem('accessToken');
      // var brokerRegistartion = '/api/ap/broker/registrationNew1';
      // var brokerRegistartion = '/api/ap/v2/broker/registration/withGroupContact';

      var brokerRegistartion = '/api/ap/v3/broker/registration';

      var requestOptions: any = {
        method: 'POST',

        body: JSON.stringify(inputData),

        redirect: 'follow',
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + brokerRegistartion, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // console.log(response);

          response = JSON.parse(response);

          if (response['status'] == 200) {
            $('#BrokerSharedNewDetails').modal('hide')

            let inputData = {
              "brokerId": response.data.broker.id,
              "brokerName": response.data.broker.name,
              "brokerType": response.data.broker.brokerType
            }
            this.brokersalesCodes.push({
              brokerId: response.data.broker.id,
              brokerName: response.data.broker.name,
              commission: '',
            });

            this.labeldata = []
            this.realdata = []
            for (let i = 0; i < this.brokersalesCodes.length; i++) {
              this.labeldata.push(this.brokersalesCodes[i].brokerName);
              this.realdata.push(this.brokersalesCodes[i].commission);
              // this.colordata.push(this.chartInfo[i].colorcode);
            }
            this.createChart(this.labeldata, this.realdata);


            if (this.brokersalesCodes.length == this.broker['brokerCount'].value) {
              this.showSharedBrokerList = false
            }
            else {
              this.showSharedBrokerList = true
            }
            const preservedValues = {
              brokerCount: this.brokerregform.get('brokerCount')?.value,

              brokerShare: this.brokerregform.get('brokerShare')?.value

            };
            this.brokerregform.reset(preservedValues);
            this.adminform.reset();
            this.licenseform.reset();
            this.formCreation.reset();
            this.adminData = [];
            this.addadminform = true
            this.showaddadmin = false
            this.addlicenseformData = []
            this.addlicenseformtable = false;
            this.addlicenseform = true;
            this.addEOform = true
            this.showaddEOdetails = false

            this.eoform.reset();
            console.log(this.brokersalesCodes)
            this.sharedBrokerData.push(inputData)
            this.showsoleAdvisorData = false;
            this._LoaderService.HideLoader();
            this.showsalestrackinCodeAuto = true;
            // this.showAdvisorAdvData = true;
            this.salesTrackingInfo = response.data.broker;

            // this.getBrokerProfiles(response.data.broker.id);
            // this.broker['parentlogo'].setValidators([Validators.required]);
            // this.broker['parentdisclosure'].setValidators([
            //   Validators.required,
            // ]);
            // this.broker['signupForm'].setValidators([Validators.required]);

            // this.broker['parentlogo'].updateValueAndValidity();
            // this.broker['parentdisclosure'].updateValueAndValidity();
            // this.broker['signupForm'].updateValueAndValidity();
            // var getClients = '/api/ap/v2/broker/registration/withGroupContact';
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + getClients
            // ]);

            // var getClientsData = '/api/ap/brokers/details';

            // let prefetchurls = [];

            // let Data = [
            //   {
            //     url: environment.apiUrl + getClientsData,
            //     // fetch options
            //     options: {
            //       mode: 'cors',
            //       headers: {
            //         Authorization:
            //           'Bearer ' + sessionStorage.getItem('accessToken'),
            //         'Content-Type': 'application/json',
            //       },
            //     },
            //   },
            // ];
            // prefetchurls = Data;

            // // postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {

            // // })

            // // $('#sumamryModel').modal('show');
            // this.salesTrackingCodeShares =
            //   response.data.salesTrackingCodeShares;
            // this.finalSummaryDataForm = response.data.form;
            // this.finalSummaryBrookerDataName = response.data.broker.name;
            // this.finalSummaryBrookerDataid = response.data.broker.id;
            // this.finalSumamryBrokerType = response.data.broker.brokerType;
            // this.finalSumamryBrokersalesTrackingCode =
            //   response.data.broker.salesTrackingCode;

            // this.finalSummaryBrookerDataBrokerType = response.data.broker.name;

            // // response.data.information.EOinsurence.EOIexpiryDate = moment(response.data.information.EOinsurence.EOIexpiryDate).format('MMM-DD-YYYY');

            // this.finalSummaryDataEOinsurance.push(
            //   response.data.information.EOinsurence
            // );
            // console.log({ final: this.finalSummaryDataEOinsurance });
            // // this.finalSummaryDataEOinsurance=response.data.information.EOinsurence;

            // this.finalSummaryDatalicense = response.data.information.licenses;
            // this.brokerCommissions =
            //   response.data.information.brokerCommissions;

            // this.brokerregform.reset();
            // this.licenseform.reset();
            // this.formCreation.reset();

            // sessionStorage.setItem('addlicenseformData', '');
            // sessionStorage.setItem('addformDetails', '');
            // this.http.post(environment.apiUrl + '/api/ap/v2/global/set-adminAdvisors',{wait:true}).subscribe((newResponse) => {
            //   this.store.dispatch(loadAdvisorDataSuccess({advisorData:[]}))
            //   this.store.dispatch(loadAdvisorData())
            // })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => { })
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
                headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
              }).subscribe((res) => {
              console.log({ res })
            })
          }
          else {
            this._LoaderService.HideLoader();

            Swal.fire({ title: 'Error', text: response.message });
          }
        });
    }
  }
  public submitbasicFormInfo() {
    // Object.keys(this.brokerregform.controls).forEach((val, key) => console.log(`${val}: ${this.brokerregform.controls[val].value}`))

    $('#sumamryModel').modal('hide');
    this._LoaderService.HideLoader();
    this.router.navigate(['/manageAdvisors']);
    console.log(this.formCreation.value);
    console.log(this.addformDetails)


    this.plansIds.length <= 0 && this.showaddform
      ? (this.saveError = true)
      : (this.saveError = false);
    console.log(this.plansIds.length <= 0, this.formCreation.invalid);

    if (this.addformDetails.length == 0) {
      // console.log(this.formCreation.value);

      // const invalid = [];
      // const controls = this.formCreation.controls;
      // for (const name in controls) {
      //   if (controls[name].invalid) {
      //     invalid.push(name);
      //   }
      // }

      this.formCreation.markAllAsTouched();
      // this.scrollToFirstInvalidControl1();
      // if (this.saveError) {
      //   const buttonToScrollTo =
      //     this.elementRef.nativeElement.querySelector('#scrollTarget');
      //   console.log({ buttonToScrollTo });

      //   buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      // }
    } else {
      this._LoaderService.ShowLoader();

      let data: any = {
        formType: this.formCreation.value.Signupformtype,
        name: this.formCreation.value.formName,
        description: this.formCreation.value.formDescription,
        link: this.formCreation.value.formLink,
        planLevels: '',
      };

      console.log(data);
      this.SignupFormData.push(data);



      let FormDetails: any = this.addformDetails;

      var formdata = new FormData();

      for (let i = 0; i < FormDetails.length; i++) {
        formdata.append('formLogo' + [i + 1] + '', FormDetails[i].logo);
      }

      // formdata.append('disclosureAgreement', disclousreDetails);
      formdata.append('formDetails', JSON.stringify(this.addformDetails) || '');
      formdata.append('broker_name', '');
      formdata.append('sales_tracking_code', '');
      formdata.append('logo', '');

      console.log(formdata)


      var accessToken = sessionStorage.getItem('accessToken');

      var brokerRegistartion =
        '/api/ap/v2/broker/' + this.profileBasedOriginalId + '/createFormWithLogo';

      var requestOptions: any = {
        method: 'POST',

        body: formdata,

        redirect: 'follow',
        headers: {
          Authorization: 'Bearer ' + accessToken
        },
      };

      // console.log(requestOptions)
      // $('#sumamryModel').modal('hide');
      // this._LoaderService.HideLoader();
      // this.router.navigate(['/manageAdvisors']);
      // fetch(environment.apiUrl + brokerRegistartion, requestOptions)
      //   .then((response) => response.text())

      //   .then(async (response: any) => {
      //     // console.log(response);
      //     response = JSON.parse(response);

      //     if (response['status'] == 200) {
      //       $('#sumamryModel').modal('hide');
      //       this._LoaderService.HideLoader();
      //       this.router.navigate(['/manageAdvisors']);

      //     } else {
      //       this._LoaderService.HideLoader();

      //       Swal.fire({ title: 'Error', text: response.message });
      //     }
      //   });
    }
  }


  checkAdvsiorNameExist() {
    let advsior = this.broker['brokersName'].value;
    let accessToken = sessionStorage.getItem('accessToken');
    let endPoint = '/api/ap/broker/validateName';
    let inputData = {
      'name': advsior,
      'description': ''
    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })
        return false;
      }
      else {//Already exist
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {
          if (result.isConfirmed) {
            this.broker['brokersName'].setValue('');
          }
        });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message ?? error.error.message })
    })
  }
  checkAdvsiorNameExistShared() {
    let advsior = this.brokerShared['brokersName'].value;
    let accessToken = sessionStorage.getItem('accessToken');
    let endPoint = '/api/ap/broker/validateName';
    let inputData = {
      'name': advsior,
      'description': ''
    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })
        return false;
      }
      else {//Already exist
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {
          if (result.isConfirmed) {
            this.broker['brokersName'].setValue('');
          }
        });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message ?? error.error.message })
    })
  }
  public checkCommisionCode(event: any) {
    console.log(this.brokersalesCodes)
    this.labeldata = []
    this.realdata = []

    // if(this.brokersalesCodes.length==this.broker['brokerCount'].value){
    const totalValue = this.brokersalesCodes.reduce((sum, item) => sum + +item.commission, 0);

    console.log(totalValue); // Output: 100

    this.totalValue = totalValue

    if (totalValue === 100) {
      // this.showsharedformData =true

      this.checkAdvsiorSharedNameExist()
    }
    else {
      this.showsharedformData = false
    }
    // }
    // else{
    //   this.showSharedBrokerList =true
    // }

    let data = this.brokersalesCodes
    for (let i = 0; i < data.length; i++) {
      this.labeldata.push(data[i].brokerName);
      this.realdata.push(data[i].commission);
      // this.colordata.push(this.chartInfo[i].colorcode);
    }




    this.createChart(this.labeldata, this.realdata);
    // this.chart.destroy();

  }

  checkAdvsiorSharedNameExist() {
    const convertedItems = this.brokersalesCodes.map(item => ({
      ...item,
      commission: Number(item.commission)
    }));
    let advsior = this.broker['brokersName'].value;
    let accessToken = sessionStorage.getItem('accessToken');
    let endPoint = '/api/ap/broker/validateShares';
    let inputData = {
      "brokerDetails": convertedItems,

    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        this.showsharedformData = true
        // this.brokerregform.reset()
        // this.broker['brokersName'].setValue('')
        return false;
      }
      else {//Already exist
        this.showsharedformData = false
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {
          if (result.isConfirmed) {
            // this.broker['brokersName'].setValue('');
          }
        });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message ?? error.error.message })
    })
  }

  public submitSharedNewandexisting() {
    // Object.keys(this.brokerregform.controls).forEach((val, key) => console.log(`${val}: ${this.brokerregform.controls[val].value}`))

    // console.log(this.brokerSharedregform.value);

    // return;
    // console.log(this.brokersalesCodes)

    // this.plansIds.length <= 0 && this.showaddform
    //   ? (this.saveError = true)
    //   : (this.saveError = false);
    // console.log(this.plansIds.length <= 0, this.formCreation.invalid);

    if (this.brokerSharedregform.invalid || this.saveError) {
      console.log(this.brokerSharedregform.value);

      const invalid = [];
      const controls = this.brokerSharedregform.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid);

      this.brokerSharedregform.markAllAsTouched();


      this.scrollToFirstInvalidControl1();
      if (this.saveError) {
        const buttonToScrollTo =
          this.elementRef.nativeElement.querySelector('#scrollTarget');
        console.log({ buttonToScrollTo });

        buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      this._LoaderService.ShowLoader();








      // if(this.brokerregform.value.stc_generation =="true"){
      // console.log("1")

      // }
      // else{
      //   console.log("2")
      //   this.brokerregform.value.user_generated_stc = "false"
      // }

      const convertedItems = this.brokersalesCodes.map(item => ({
        ...item,
        commission: Number(item.commission)
      }));
      let secondaryEmail = this.brokerSharedregform.value.secondaryEmail || '';
      let thirdEmail = this.brokerSharedregform.value.thirdEmail || '';

      if (thirdEmail) {
        secondaryEmail = `${secondaryEmail ? `${secondaryEmail},` : ''
          }${thirdEmail}`;
      }
      let inputData = {
        brokerCommissionType: 'shared',
        name: this.capitalize(this.brokerSharedregform.value.brokersName),
        parentId: +this.brokerSharedregform.value.ParentbrokerName || 1,
        brokerType: 'Advisor',
        businessNumber: undefined,
        email: undefined,
        secondaryEmail: undefined,
        address: {
          apt: '',
          line1: undefined,
          line2: undefined,
          city: undefined,
          province: undefined,
          country: undefined,
          postalCode: undefined,
          provinceId: this.state_id,
          countryId: 1,
          primaryEmail: undefined,
          secondaryEmail: undefined,
          primaryPhone: undefined,
          secondaryPhone: undefined,
        },
        groupContacts: [],
        licenses: [],
        brokerEO: undefined,
        brokerDetails: convertedItems,
        primaryBrokerId: this.brokersalesCodes[0].brokerId



      };


      // formdata.append("formDisclosureAgreement1", "");

      var accessToken = sessionStorage.getItem('accessToken');
      // var brokerRegistartion = '/api/ap/broker/registrationNew1';
      // var brokerRegistartion = '/api/ap/v2/broker/registration/withGroupContact';

      var brokerRegistartion = '/api/ap/v3/broker/registration';

      var requestOptions: any = {
        method: 'POST',

        body: JSON.stringify(inputData),

        redirect: 'follow',
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + brokerRegistartion, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // console.log(response);
          response = JSON.parse(response);

          if (response['status'] == 200) {
            this.showsoleAdvisorData = false;
            this._LoaderService.HideLoader();
            // this.http.post(environment.apiUrl + '/api/ap/v2/global/set-adminAdvisors',{wait:true}).subscribe((newResponse) => {
            //   this.store.dispatch(loadAdvisorDataSuccess({advisorData:[]}))
            //   this.store.dispatch(loadAdvisorData())
            // })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => { })
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
                headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
              }).subscribe((res) => {
              console.log({ res })
            })
            Swal.fire({ title: 'Info', text: response.message });
            this.router.navigate([
              '/manageAdvisors'
            ]);
            // window.location.reload()


          } else {
            this._LoaderService.HideLoader();

            Swal.fire({ title: 'Error', text: response.message });
          }
        });
    }
  }

  getProfilebasedid(event) {
    console.log(event);
    this.profileBasedOriginalId = +event.target.value;
  }
  getBrokerProfiles(brokerId) {
    var endPoint = '/api/ap/broker/' + brokerId + '/profiles';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {

          this.brokerProfileslist = this.parseAllValuesInArray(response.data.profiles);
          console.log(this.brokerProfileslist)
        }
      });
  }


  formConfig1(id) {

    var endPoint = `/api/ap/broker/formConfig?currentBrokerId=${id}`;
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            // this.getBrokerDetails()
            // this.getServiceWorkerDetails()


            this.productsArray = response.data.packages





            // for (let i = 0; i < this.productsArray.length; i++) {

            //   for (let j = 0; j < this.productsArray[i].planGroups.length; j++) {

            //     this.productsArrayList.push(this.productsArray[i].planGroups[j])
            //   }






            // }
          } else {
            Swal.fire({ title: 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
        }
      );
  }
  parseAllValuesInArray(arr: any[]): any[] {
    return arr.map(obj => {
      const parsedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          try {
            parsedObj[key] = JSON.parse(obj[key]);
          } catch (e) {
            parsedObj[key] = obj[key]; // If parsing fails, retain original value
          }
        }
      }
      return parsedObj;
    });
  }
  copyInputMessage(inputElement) {
    console.log(inputElement);
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }
  viewfulldetailsofBroker(id) {
    $('#sumamryModel').modal('hide');
    this.router.navigate([
      '/manageAdvisors/editAdvisor/' + this.finalSummaryBrookerDataid,
    ]);
    // alert(id)
  }
  closesummarydetails() {
    this.router.navigate([
      '/manageAdvisors'
    ]);
    // window.location.reload();
  }
  scrollToFirstInvalidControl1() {
    // const firstInvalidControl: HTMLElement =
    //   this.elementRef.nativeElement.querySelector(
    //     'form .ng-invalid' || 'form .ng-untouched'
    //   );
    const firstInvalidControl: HTMLElement = this.elementRef.nativeElement.querySelector(
      'form .ng-invalid') || this.elementRef.nativeElement.querySelector('form .ng-untouched');


    // console.log(firstInvalidControl)
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    });
  }
  getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 300;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  salesTrackingFormater() {
    const inputValue = this.broker['sales_tracking_code'].value;

    this.broker['sales_tracking_code'].setValue(
      this.salesTrackingFormaterFormatter.transform(inputValue),
      { emitEvent: false }
    );
  }
  sharedBroker(event: any) {
    // this.showsoleAdvisorData = false;
    this.noofbrokerscount = true;

  }

  // sharedBrokerType(event: any) {
  //   // this.showsoleAdvisorData = false;
  //     this.showSharedNewData = true


  // }

  sharedBrokerType(event: any) {
    console.log(event.target.value)
    console.log(typeof event.target.value)
    if (event.target.value == "true") {

      this.showSharedAdvisorData = false;

      // this.noofbrokerscount =true
    }
    else {
      this.showSharedAdvisorData = true;
      // this.noofbrokerscount =false
    }

  }

  postNewBrokerResults(data: any) {

    console.log(data)
    let newSharedData = []
    let inputData = {
      brokerCommissionType: 'shared',
      name: this.capitalize(data.brokersName),
      parentId: +data.ParentbrokerName,
      brokerType: this.brokerTypeName,
      businessNumber: data.businessnumber || '',
      email: data.primaryEmail || '',

      apt: '',
      line1: this.capitalize(data.streetAddress),
      line2: this.capitalize(data.streetAddress2) || '',
      city: this.capitalize(data.city) || '',
      province: data.Province || '',
      country: this.capitalize(data.country),
      postalCode: data.postalCode || '',
      provinceId: this.state_id,
      countryId: 1,
      primaryEmail: data.primaryEmail || '',
      secondaryEmail: '',
      primaryPhone: data.primaryPhone || '',
      secondaryPhone: data.secondaryPhone || '',



    };
    newSharedData.push(inputData)
    console.log(inputData)
  }

  soleBroker(event: any) {
    this.showsharedformData = false
    console.log(event.target.value)
    console.log(typeof event.target.value)
    if (event.target.value == "true") {
      this.showsoleAdvisorData = false;
      this.noofbrokerscount = true
      this.broker['brokerCount'].setValue('');
      this.showsalestrackinCodeAuto = false;
      this.brokersalesCodes = []
      this.totalValue = 0
    }
    else {
      this.showsoleAdvisorData = true;
      this.noofbrokerscount = false
      this.showsalestrackinCodeAuto = false;
      this.showSharedBrokerList = false



    }
    const preservedValues = {
      brokerCount: this.brokerregform.get('brokerCount')?.value,

      brokerShare: this.brokerregform.get('brokerShare')?.value,
      brokerStatus: this.brokerregform.get('brokerStatus')?.value

    };
    this.brokerregform.reset(preservedValues);
    this.adminform.reset();
    this.licenseform.reset();
    this.formCreation.reset();
    this.adminData = []
    this.addlicenseformData = []
    this.EOinsurenceInfo = '';
    this.addadminform = true
    this.showaddadmin = false
    this.addlicenseform = true
    this.addlicenseformtable = false
    this.addEOform = true
    this.showaddEOdetails = false
    // this.noofbrokerscount = false;
    // this.showSharedBrokerList = false;
  }
  getbrookercount(e: any) {
    if (this.brokersalesCodes.length == this.broker['brokerCount'].value) {
      this.showSharedBrokerList = false
    }
    else {
      if (this.brokersalesCodes.length > this.broker['brokerCount'].value) {
        Swal.fire({
          title: 'Info',
          text: "The shared brokers list does not match the number of brokers count.",
        });
        this.showSharedBrokerList = false
        return false
      }
      else {
        this.showSharedBrokerList = true
      }

    }
  }
  public capitalize(str: any) {
    // if (str) {
    //   return str.charAt(0).toUpperCase() + str.slice(1);
    // }
    if (str == null) return '';
    const arr = str.split(' ');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(' ');
    return str2;
  }

  closePopup(id: any) {
    $(`#${id}`).hide();
  }

  isNumberKey(evt) {
    // alert("s")
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  closePlans(){
    this.showaddplans = false;
    this.showeditplans = false;
  }
}
export function postalcodeValidator(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null;
}

export function emailCheck(control: AbstractControl) {
  const disallowedCharacters = '.';
  console.log('control', control.value);
  let notAlloewdSecvence = [
    '"',
    '#',
    '$',
    '%',
    '(',
    ')',
    '.',
    ',',
    ':',
    ';',
    '<',
    '>',
    '@',
    '[',
    ']',
  ];

  let uniqueValu = [...new Set(control.value.split(''))];

  const regexPattern = new RegExp(`[${disallowedCharacters}]{2,}`);
  if (regexPattern.test(control.value)) {
    return { invalidEmail: true };
  }
  return null;
}
